import {
    Checkbox,
    Button,
    Col,
    Divider,
    Dropdown,
    Form,
    Input,
    Menu,
    message,
    Modal,
    Popover,
    Row,
    Switch,
    Tabs,
    Radio,
} from 'antd';
import { Content } from 'antd/lib/layout/layout';
import moment from 'moment';
import { useEffect, useRef, useState, useMemo } from 'react';
import styled, { keyframes } from 'styled-components';
import {
    ActionButtonGroup,
    CloseButton,
    Icon,
    ModalScreen,
    PositionController,
    Spacer,
    Text,
    Title,
} from '../styles/commonStyle';
import { commonTheme } from '../styles/theme';
// import "../styles/CreateAndModifyCouponModal.css";
import { useDispatch, useSelector } from 'react-redux';
import { CustomButton } from './CustomButton';

import { getCoupon } from '../api/couponAPI';
import { getCustomerCountBySegment, getGroupSegments } from '../api/messageAPI';
import { getAutoMessageOptionConfig } from '../config/autoMessageOptionConfig';
import {
    createAutoMessageAction,
    getAutoMessageSettingAction,
    getKakaoAlimTalkCountAction,
    modifyAutoMessageSettigAction,
    getKakaoTemplatesAction,
} from '../reducers/message';
import '../styles/MessageSetting.css';
import AutomaticMessageNameLabel from './AutomaticMessageNameLabel';
import MessageInfoNoticeModal from './MessageInfoNoticeModal';
import NoticeModal from './NoticeModal';
import NumberTypeData from './NumberTypeData';
import ScheduleTypeData from './ScheduleTypeData';
import { KakaoPreview } from './KakaoPreview';
import CustomSpinner from './CustomSpinner';

const { TabPane } = Tabs;

const getDefaultSegmentTitle = (defaultTitle) => {
    switch (defaultTitle) {
        case 'ACTIVE':
            return '활성(전체)';
        case 'EXPIRED':
            return '만료';
        case 'UPCOMING':
            return '예정';
        case 'EXPIRING_SOON':
            return '임박';
        case 'HOLDING':
            return '홀딩';
        case 'UNREGISTERED':
            return '미등록';
        case 'MEMBERSHIP_ACTIVE':
            return '(구)회원권 활성';
        case 'ONLY_ACTIVE':
            return '활성';
        case 'NEW_ARRIVAL_CARE':
            return '신규 정착 케어';
        case 'CHURN_RISK':
            return '이탈 위험군';
        case 'VIP':
            return 'VIP';
        default:
            return '-';
    }
};

const customerRealtiveOptionList = [
    {
        id: 1,
        label: '고객 추가',
        function_type: 'NEW_CUSTOMER_CREATED',
        related: 'customer',
        send_time_type: 'IMMEDIATELY',
        send_time_types: ['IMMEDIATELY', 'RELATIVELY_TIME'],
    },
    {
        id: 21,
        label: '세그먼트 인입',
        function_type: 'CUSTOMER_SEGMENT_ENTRY_ALARM',
        related: 'customer',
        send_time_type: 'RELATIVELY_TIME',
        send_time_types: ['RELATIVELY_TIME'],
    },
    {
        id: 2,
        label: '멤버십/이용권 신규 구매 시',
        function_type: 'CUSTOMER_FIRST_BUY_TICKET_ALARM',
        related: 'customer',
        send_time_type: 'IMMEDIATELY',
    },
    {
        id: 3,
        label: '대여권/락커 구매 시',
        function_type: 'CUSTOMER_BUY_RENTAL_TICKET_ALARM',
        related: 'customer',
        send_time_type: 'IMMEDIATELY',
    },
    {
        id: 4,
        label: '계약 완료 시',
        function_type: 'CUSTOMER_CONTRACT_DONE_ALARM',
        related: 'customer',
        send_time_type: 'IMMEDIATELY',
    },
    {
        id: 5,
        label: '생일자',
        function_type: 'CUSTOMER_BIRTHDAY_ALARM',
        related: 'customer',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 6,
        label: '멤버십/이용권 재구매 시',
        function_type: 'CUSTOMER_REBUY_TICKET_ALARM',
        related: 'customer',
        send_time_type: 'IMMEDIATELY',
    },
    {
        id: 7,
        label: '대여권 구매 시',
        function_type: 'CUSTOMER_BUY_RENTAL_SPORTS_TICKET_ALARM',
        related: 'customer',
        send_time_type: 'IMMEDIATELY',
    },
    {
        id: 8,
        label: '장기 미출석',
        function_type: 'CUSTOMER_NON_ATTENDANCE',
        related: 'customer',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 9,
        label: '쿠폰 만료 안내',
        function_type: 'CUSTOMER_COUPON_EXPIRE_ALARM',
        related: 'customer',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 10,
        label: '활성 회원에게(1회발송)',
        function_type: 'ACTIVE_CUSTOMER_ALARM',
        related: 'customer',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 11,
        label: '락커 구매 시',
        function_type: 'CUSTOMER_BUY_RENTAL_LOCKER_TICKET_ALARM',
        related: 'customer',
        send_time_type: 'IMMEDIATELY',
    },
    {
        id: 12,
        label: '기간제 락커 배정 시',
        function_type: 'PERIODIC_LOCKER_ASSIGNMENT_ALARM',
        related: 'customer',
        send_time_type: 'IMMEDIATELY',
    },
    // {
    //     id: 12,
    //     label: '장기 미수업 (수강권) (준비중)',
    //     function_type: 'LESSON_NON',
    //     disabled: true,
    //     related: 'customer',
    //     send_time_type: 'RELATIVELY_TIME',
    // },
    {
        id: 13,
        label: '출석 시',
        function_type: 'CUSTOMER_ATTENDANCE',
        related: 'customer',
        send_time_type: 'IMMEDIATELY',
    },
    {
        id: 14,
        label: '비활성 회원에게(1회발송)',
        function_type: 'INACTIVE_CUSTOMER_ALARM',
        related: 'customer',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 15,
        label: '일일락커 배정 시',
        function_type: 'SMART_DAILY_LOCKER_ASSIGNMENT',
        related: 'customer',
        send_time_type: 'IMMEDIATELY',
    },
];

const productRelativeOptionList = [
    {
        id: 1,
        label: '멤버십 만료 전',
        function_type: 'MEMBER_TICKET_EXPIRE_ALARM',
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 2,
        label: '이용권 만료 전',
        function_type: 'LESSON_TICKET_EXPIRE_ALARM',
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 3,
        label: '예약권 만료 전',
        function_type: 'CLASS_TICKET_EXPIRE_ALARM',
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 4,
        label: '상품 홀딩 시',
        function_type: 'CUSTOMER_HOLDING_NEW_ALARM',
        related: 'product',
        send_time_type: 'IMMEDIATELY',
    },
    {
        id: 5,
        label: '멤버십 만료 시',
        function_type: 'MEMBER_TICKET_EXPIRE_DATE_ALARM',
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 6,
        label: '이용권 만료 시',
        function_type: 'LESSON_TICKET_EXPIRE_DATE_ALARM',
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 7,
        label: '예약권 만료 시',
        function_type: 'CLASS_TICKET_EXPIRE_DATE_ALARM',
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 8,
        label: '홀딩 종료 임박',
        function_type: 'CUSTOMER_HOLDING_EXPIRE_ALARM',
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 9,
        label: '프로그램 만료 전',
        function_type: 'LESSON_PROGRAM_EXPIRE_ALARM',
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 10,
        label: '대여권 만료 전', // 운동복 만료 전
        function_type: 'SPORTS_EXPIRE_ALARM',
        // disabled: true,
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 11,
        label: '입장권 만료 전',
        function_type: 'ENTRY_TICKET_EXPIRE_ALARM',
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 12,
    },
    {
        id: 13,
        label: '프로그램 만료 시',
        function_type: 'LESSON_PROGRAM_EXPIRE_DATE_ALARM',
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 14,
        label: '대여권 만료 시',
        function_type: 'RENTAL_EXPIRE_DATE_ALARM',
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 15,
        label: '입장권 만료 시',
        function_type: 'ENTRY_TICKET_EXPIRE_DATE_ALARM',
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 16,
    },
    {
        id: 17,
        label: '대여권 종류 만료 전',
        function_type: 'RENTAL_PROGRAM_EXPIRE_ALARM',
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 18,
        label: '락커 만료 전', // 락커 만료 전
        function_type: 'LOCKER_EXPIRE_ALARM',
        // disabled: true,
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 19,
        label: '시설권 만료 전',
        function_type: 'FACILITY_TICKET_EXPIRE_ALARM',
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 20,
    },
    {
        id: 21,
        label: '대여권 종류 만료 시',
        function_type: 'RENTAL_PROGRAM_EXPIRE_DATE_ALARM',
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 22,
        label: '락커 만료 시',
        function_type: 'LOCKER_EXPIRE_DATE_ALARM',
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 23,
        label: '시설권 만료 시',
        function_type: 'FACILITY_TICKET_EXPIRE_DATE_ALARM',
        related: 'product',
        send_time_type: 'RELATIVELY_TIME',
    },
    {
        id: 24,
    },
];

const reservationRelativeOptionList = [
    {
        id: 1,
        label: '수업 예약 시',
        function_type: 'LESSON_BOOK_ALARM',
        related: 'reservation',
        send_time_type: 'IMMEDIATELY',
    },
    {
        id: 2,
        label: '시설 예약 시',
        function_type: 'FACILITY_BOOK_ALARM',
        related: 'reservation',
        send_time_type: 'IMMEDIATELY',
    },
    { id: 3 },
    { id: 4 },
    {
        id: 5,
        label: '수업 예약 취소 시',
        function_type: 'LESSON_CANCEL_BOOK_ALARM',
        related: 'reservation',
        send_time_type: 'IMMEDIATELY',
    },
    {
        id: 6,
        label: '시설 예약 취소 시',
        function_type: 'FACILITY_CANCEL_BOOK_ALARM',
        related: 'reservation',
        send_time_type: 'IMMEDIATELY',
    },
    { id: 7 },
    { id: 8 },
    { id: 9 },
    {
        id: 10,
        label: '시설 예약 변경 시',
        function_type: 'FACILITY_CHANGE_BOOK_ALARM',
        related: 'reservation',
        send_time_type: 'IMMEDIATELY',
    },
];

const relatedStringList = {
    customer: '고객관련',
    product: '상품관련',
    reservation: '예약관련',
};
const autoMessageTypesList = [
    {
        label: '문자메시지',
        value: 'SMS',
        tooltipContent: (
            <div>
                고객에게 일반 문자(SMS/LMS)로 발송됩니다.
                <br />
                다른 전송 방식과 함께 선택할 수 있습니다.
            </div>
        ),
    },
    {
        label: '운톡 푸쉬 알림',
        value: 'PUSH',
        tooltipContent: (
            <div>
                브로제이 앱(운톡)을 설치한 고객에게 푸쉬 알림으로 전송됩니다.
                <br />
                다른 전송 방식과 함께 선택할 수 있습니다.
            </div>
        ),
    },
    {
        label: '스마트 전송',
        value: 'SMART_PUSH',
        tooltipContent: (
            <div>
                운톡 푸쉬 알림을 먼저 전송하고, 실패할 경우 자동으로
                문자메시지가 발송됩니다.
                <br />
                <span style={{ fontWeight: 700, textDecoration: 'underline' }}>
                    문자메시지와 운톡 푸쉬 알림을 중복으로 선택할 수 없습니다.
                </span>
            </div>
        ),
    },
    {
        label: '알림톡',
        value: 'KAKAO_ALIM_TALK',
        tooltipContent: (
            <div>
                <span style={{ fontWeight: 700, textDecoration: 'underline' }}>
                    카카오톡 알림톡으로 먼저 전송
                </span>
                되며, 고객이 수신할 수 없는 경우{' '}
                <span style={{ fontWeight: 700, textDecoration: 'underline' }}>
                    자동으로
                </span>
                <br />
                <span style={{ fontWeight: 700, textDecoration: 'underline' }}>
                    문자메세지로 전환됩니다.
                </span>{' '}
                다른 전송 방식과 함께 선택할 수 있습니다.
            </div>
        ),
    },
];

const MAX_BYTES = 2000;

// 회원권 만료 전, 회원권 만료 시, 수강권 만료 전, 수강권 만료 시, 락커 만료, 운동복 만료를 나타내는 조건(이 경우에만 템플릿을 두개 중 하나로 선택 가능)
const basicDualFunctionTypes = [
    'MEMBER_TICKET_EXPIRE_ALARM',
    'MEMBER_TICKET_EXPIRE_DATE_ALARM',
    'LESSON_TICKET_EXPIRE_ALARM',
    'LESSON_TICKET_EXPIRE_DATE_ALARM',
    'LOCKER_EXPIRE_ALARM',
    'SPORTS_EXPIRE_ALARM',
    'LESSON_PROGRAM_EXPIRE_ALARM',
    'RENTAL_PROGRAM_EXPIRE_ALARM',
    'LOCKER_EXPIRE_DATE_ALARM',
    'SPORTS_EXPIRE_DATE_ALARM',
    'RENTAL_EXPIRE_DATE_ALARM',
];

const withMileageFunctionTypes = [
    'MEMBER_TICKET_EXPIRE_ALARM_WITH_MILEAGE',
    'MEMBER_TICKET_EXPIRE_DATE_ALARM_WITH_MILEAGE',
    'LESSON_TICKET_EXPIRE_ALARM_WITH_MILEAGE',
    'LESSON_TICKET_EXPIRE_DATE_ALARM_WITH_MILEAGE',
    'LOCKER_EXPIRE_ALARM_WITH_MILEAGE',
    'SPORTS_EXPIRE_ALARM_WITH_MILEAGE',
    'LESSON_PROGRAM_EXPIRE_ALARM_WITH_MILEAGE',
    'RENTAL_PROGRAM_EXPIRE_ALARM_WITH_MILEAGE',
    'LOCKER_EXPIRE_DATE_ALARM_WITH_MILEAGE',
    'SPORTS_EXPIRE_DATE_ALARM_WITH_MILEAGE',
    'RENTAL_EXPIRE_DATE_ALARM_WITH_MILEAGE',
];

const dualFunctionTypes = [
    ...basicDualFunctionTypes,
    ...withMileageFunctionTypes,
];

const numberEnabledFunctionTypes = [
    'MEMBER_TICKET_EXPIRE_ALARM',
    'LESSON_TICKET_EXPIRE_ALARM',
    'CLASS_TICKET_EXPIRE_ALARM',
    'ENTRY_TICKET_EXPIRE_ALARM',
    'FACILITY_TICKET_EXPIRE_ALARM',
];

const dualTemplateRadio = [
    {
        label: '기본 템플릿',
        value: 'BASIC',
    },
    {
        label: '잔여 마일리지 포함 템플릿',
        value: 'WITH_MILEAGE',
    },
];

const AdInfoPopoverContent = () => {
    return (
        <div>
            <Title
                color="#000"
                style={{ fontSize: '12px', lineHeight: '17.38px' }}
            >
                광고성 정보에 대한 판단 기준
            </Title>
            <Spacer size={6} />
            <Text size="12px" color="#000" style={{ display: 'block' }}>
                1. 툭가/할인 상품 안내
            </Text>
            <Text size="12px" color="#000" style={{ display: 'block' }}>
                2. 상품 및 서비스 홍보를 위한 프로모션/이벤트 또는 발신인의
                이미지 홍보
            </Text>
            <Text size="12px" color="#000" style={{ display: 'block' }}>
                3. 주된 정보가 아니더라도 부수적으로 위 [1,2]의 내용을 포함한
                경우
            </Text>
            <Spacer size={3} />
            <Text size="12px" color="#A4A4A4" style={{ display: 'block' }}>
                * 운톡 push 알림인 경우에는 해당되지 않습니다.
            </Text>
        </div>
    );
};

const AutoInputPopoverContent = () => {
    return (
        <div>
            <Title
                color="#000"
                style={{ fontSize: '12px', lineHeight: '17.38px' }}
            >
                자동 입력 방법 예시
            </Title>
            <Spacer size={6} />
            <Text size="12px" color="#000" style={{ display: 'block' }}>
                안녕하세요{' '}
                <Text fontWeight={700} size="12px" color="#FA943D">
                    #센터명#
                </Text>
                입니다.
            </Text>
            <Text size="12px" color="#000" style={{ display: 'block' }}>
                <Text fontWeight={700} size="12px" color="#FA943D">
                    #보유 회원권명#
                </Text>
                의 만료일이{' '}
                <Text fontWeight={700} size="12px" color="#FA943D">
                    #전송기준#
                </Text>
                남으셨습니다.
            </Text>
            <Text size="12px" color="#000" style={{ display: 'block' }}>
                재등록 시 문의 부탁드립니다. 감사합니다 :)
            </Text>
            <Spacer size={6} />
            <Text
                fontWeight={700}
                size="12px"
                color="#EB5252"
                style={{ display: 'block' }}
            >
                *주의*
            </Text>
            <Text size="12px" color="#000" style={{ display: 'block' }}>
                자동입력문구에 따라{' '}
                <ins>글자수가 추가적으로 발생할 수 있습니다.</ins>
            </Text>
        </div>
    );
};

const getFinalFunctionType = (baseType, templateOption) => {
    const isBasic = basicDualFunctionTypes.includes(baseType);

    if (!isBasic) return baseType;

    switch (templateOption) {
        case 'WITH_MILEAGE':
            return `${baseType}_WITH_MILEAGE`;
        case 'BASIC':
        default:
            return baseType;
    }
};

const stripWithMileage = (ft = '') => ft.replace(/_WITH_MILEAGE$/, '');

const relatedToTabKey = {
    customer: '1',
    product: '2',
    reservation: '3',
};

const getSendTimeTypes = (option) => {
    if (Array.isArray(option?.send_time_types)) {
        return option.send_time_types;
    }

    return option?.send_time_type ? [option.send_time_type] : [];
};

const isSendTimeTypeEnabled = (option, sendTimeType) =>
    getSendTimeTypes(option).includes(sendTimeType);

const MessageSettingModal = ({
    closeSetAddModal,
    jgroupData,
    selectedNumber,
    selectedData,
    isModify,
}) => {
    // console.log("jgroupData", jgroupData);
    const dispatch = useDispatch();
    // const couponList = useSelector((state) => state.couponReducer.couponList);
    const [couponList, setCouponList] = useState([]);
    const [alimTmpList, setAlimTmpList] = useState([]);
    const {
        createAutoMessageDone,
        createAutoMessageError,
        modifyAutoMessageDone,
        modifyAutoMessageError,
        getKakaoAlimTalkTemplatesDone,
        getKakaoAlimTalkTemplatesLoading,
        kakaoAlimTalkTemplates,
    } = useSelector((state) => state.messageReducer);
    const [isSelectOption, setIsSelectOption] = useState(() => {
        if (isModify && selectedData) {
            return false;
        } else {
            return true;
        }
    });
    const [activeOptionTab, setActiveOptionTab] = useState(() => {
        if (isModify && selectedData?.related) {
            return relatedToTabKey[selectedData.related] || '1';
        }

        return '1';
    });
    // const [isCustomerNonAttendanceModal, setIsCustomerNonAttendanceModal] =
    //   useState(false);
    const [selectedOption, setSelectedOption] = useState(() => {
        if (isModify && selectedData) {
            let newOptionList = [
                ...customerRealtiveOptionList,
                ...productRelativeOptionList,
                ...reservationRelativeOptionList,
            ];
            const baseFt = stripWithMileage(selectedData.function_type);

            let _newOptionList = newOptionList.filter(
                (data) => data.function_type === baseFt, //selectedData.function_type,
            );
            // console.log("!!", _newOptionList);
            const selectedConfig = _newOptionList[0];

            return {
                label: `${selectedConfig.label}`,
                function_type: baseFt, // `${selectedData.function_type}`,
                related: `${selectedData.related}`,
                send_time_type: `${
                    selectedData.entry_list[0].send_time_type === 'IMMEDIATELY'
                        ? 'IMMEDIATELY'
                        : 'RELATIVELY_TIME'
                }`,
                send_time_types: getSendTimeTypes(selectedConfig),
            };
        } else {
            return {
                label: '',
                function_type: '',
                related: '',
                send_time_type: '',
                send_time_types: [],
            };
        }
    });
    const [autoMessageName, setAutoMessageName] = useState(() => {
        if (isModify && selectedData) {
            return `${selectedData.name}`;
        } else {
            return '';
        }
    });
    const [immediatelyType, setImmediatelyType] = useState(() => {
        if (isModify && selectedData) {
            if (selectedData.entry_list[0].send_time_type === 'IMMEDIATELY') {
                return true;
            }
        } else {
            return false;
        }
    }); // 즉시
    const [scheduleType, setScheduleType] = useState(() => {
        if (isModify && selectedData) {
            let _checkedScheduleType = selectedData.entry_list.some(
                (data) => data.send_time_type === 'RELATIVELY_TIME',
            );
            if (_checkedScheduleType) {
                return true;
            }
        } else {
            return false;
        }
    }); // 일정 기준
    const [numberType, setNumberType] = useState(() => {
        if (isModify && selectedData) {
            let _checkedNumberType = selectedData.entry_list.some(
                (data) => data.send_time_type === 'RELATIVELY_COUNT',
            );
            if (_checkedNumberType) {
                return true;
            }
        } else {
            return false;
        }
    }); // 횟수 기준
    const [isInfoClicked, setIsInfoClicked] = useState(false);
    /**일정 기준 추가 시 사용되는 배열*/
    const [scheduleTypeList, setScheduleTypeList] = useState(() => {
        if (isModify && selectedData) {
            let _scheduleTypeList = selectedData.entry_list
                .filter((data) => data.send_time_type === 'RELATIVELY_TIME')
                .map((data) => {
                    const scheduleConfig = getAutoMessageOptionConfig(
                        selectedData.function_type,
                    ).schedule;
                    return {
                        entryKey: data.entry_key,
                        dateCount: scheduleConfig.minCount > 0
                            ? Math.max(Number(data.unit_count) || 1, 1)
                            : data.unit_count,
                        dateCountType:
                            scheduleConfig.allowedUnits.length === 1
                                ? scheduleConfig.allowedUnits[0]
                                : data.entry_unit,
                        dateCountTiming:
                            scheduleConfig.allowedTimings.length === 1
                                ? scheduleConfig.allowedTimings[0]
                                : data.entry_type,
                        dateCountTimingType:
                            data.hour >= 12 ? 'AFTERNOON' : 'MORNING',
                        sendHour:
                            data.hour === 24
                                ? 12
                                : data.hour > 12
                                ? data.hour - 12
                                : data.hour,
                        sendMinute: data.minute,
                    };
                });
            return _scheduleTypeList;
        } else {
            return [];
        }
    });
    const [cursorPosition, setCursorPosition] = useState(null);

    /**횟수 기준 추가시 사용되는 배열 state */
    const [numberTypeList, setNumberTypeList] = useState(() => {
        if (isModify && selectedData) {
            let _numberTypeList = selectedData.entry_list
                .filter((data) => data.send_time_type === 'RELATIVELY_COUNT')
                .map((data) => {
                    return {
                        count: data.unit_count,
                    };
                });
            return _numberTypeList;
        } else {
            return [];
        }
    });
    const [selectCoupon, setSelectCoupon] = useState({});
    const [isAdInformation, setIsAdInformation] = useState(() => {
        if (isModify && selectedData && selectedData.has_advertisement) {
            return true;
        } else {
            return false;
        }
    });
    const [messageTitle, setMessageTitle] = useState(() => {
        if (isModify && selectedData) {
            if (selectedData.has_advertisement) {
                return '(광고)' + selectedData.title;
            } else {
                return selectedData.title;
            }
        } else {
            return '';
        }
    });
    const [messageBody, setMessageBody] = useState(() => {
        if (isModify && selectedData) {
            return selectedData.body;
        } else {
            return '';
        }
    });
    const [autoInputWordList, setAutoInputWordList] = useState(() => {
        if (isModify && selectedData) {
            let _autoInputWordList = [
                {
                    dataType: 'CENTER_NAME',
                    label: '#센터명#',
                    previewText: `${jgroupData.jgroup_name}`,
                },
                {
                    dataType: 'MEMBER_NAME',
                    label: '#고객명#',
                    previewText: '홍길동',
                },
                {
                    dataType: 'ONTALK_LINK',
                    label: '#운톡가입링크#',
                    previewText: `센터의 원활한 사용을 위한 운톡 어플링트를 함께 보내드립니다!(링크)`,
                },
            ];
            const _lessonInputBaseList = [
                {
                    dataType: 'CENTER_NAME',
                    label: '#센터명#',
                },
                {
                    dataType: 'MEMBER_NAME',
                    label: '#고객명#',
                },
                {
                    dataType: 'PRODUCT_NAME',
                    label: '#상품명#',
                },
                {
                    dataType: 'PRODUCT_USING_TIME',
                    label: '#상품이용기간#',
                },
                {
                    dataType: 'LESSON_NAME',
                    label: '#일정명#',
                },
                {
                    dataType: 'LESSON_DATE',
                    label: '#일정일시#',
                },
            ];
            const _facilityInputBaseList = [
                {
                    dataType: 'CENTER_NAME',
                    label: '#센터명#',
                },
                {
                    dataType: 'MEMBER_NAME',
                    label: '#고객명#',
                },
                {
                    dataType: 'PRODUCT_NAME',
                    label: '#상품명#',
                },
                {
                    dataType: 'FACILITY_NAME',
                    label: '#시설명#',
                },
                {
                    dataType: 'SEAT_NAME',
                    label: '#자리명#',
                },
                {
                    dataType: 'FACILITY_USING_TIME',
                    label: '#이용일시#',
                },
            ];
            let _newAutoInputWordList;
            const baseFt = stripWithMileage(selectedData.function_type);
            if (
                getAutoMessageOptionConfig(baseFt).autoInputWordGroup ===
                'BASE'
            ) {
                return _autoInputWordList;
            }
            switch (baseFt) {
                case 'NEW_CUSTOMER_CREATED':
                case 'CUSTOMER_BIRTHDAY_ALARM':
                case 'ACTIVE_CUSTOMER_ALARM':
                case 'INACTIVE_CUSTOMER_ALARM':
                    return _autoInputWordList;
                    break;
                case 'CUSTOMER_NON_ATTENDANCE':
                    return [
                        ..._autoInputWordList,
                        {
                            dataType: 'ATTENDANCE_DATE_TIME',
                            label: '#출석시간#',
                            previewText: `YYYY-MM-DD (ddd) HH:mm:ss`,
                        },
                        {
                            dataType: 'SEND_TYPE',
                            label: '#전송기준#',
                            previewText: '',
                        },
                        {
                            dataType: 'FINAL_EXPIRE_DATE',
                            label: '#최종만료일#',
                        },
                    ];
                    break;
                case 'CUSTOMER_ATTENDANCE':
                    return [
                        ..._autoInputWordList,
                        {
                            dataType: 'ATTENDANCE_DATE_TIME',
                            label: '#출석시간#',
                            previewText: `'yyyy-MM-dd (E) HH:mm:ss'`,
                        },
                    ];
                    break;
                case 'MEMBER_TICKET_EXPIRE_ALARM':
                case 'LESSON_TICKET_EXPIRE_ALARM':
                case 'LESSON_PROGRAM_EXPIRE_ALARM':
                case 'RENTAL_PROGRAM_EXPIRE_ALARM':
                case 'FACILITY_TICKET_EXPIRE_ALARM':
                case 'ENTRY_TICKET_EXPIRE_ALARM':
                case 'CLASS_TICKET_EXPIRE_ALARM':
                    return [
                        ..._autoInputWordList,
                        ...[
                            {
                                dataType: 'PRODUCT_NAME',
                                label: '#상품명#',
                                previewText: `'상품명'`,
                            },
                            {
                                dataType: 'SEND_TYPE',
                                label: '#전송기준#',
                                previewText: '',
                            },
                            {
                                dataType: 'PAYMENT_HISTORY',
                                label: '#결제내역#',
                                previewText: `상품명 -원\n----------------------\n총결제 금액 -원`,
                            },
                            {
                                dataType: 'EXPIRE_DATE',
                                label: '#만료일#',
                            },
                            {
                                dataType: 'MILEAGE',
                                label: '#마일리지#',
                            },
                        ],
                    ];
                    break;
                case 'LESSON_TICKET_EXPIRE_DATE_ALARM':
                case 'MEMBER_TICKET_EXPIRE_DATE_ALARM':
                case 'LESSON_PROGRAM_EXPIRE_DATE_ALARM':
                case 'RENTAL_PROGRAM_EXPIRE_DATE_ALARM':
                case 'FACILITY_TICKET_EXPIRE_DATE_ALARM':
                case 'ENTRY_TICKET_EXPIRE_DATE_ALARM':
                case 'CLASS_TICKET_EXPIRE_DATE_ALARM':
                    _newAutoInputWordList = [
                        {
                            dataType: 'PRODUCT_NAME',
                            label: '#상품명#',
                            previewText: `'상품명'`,
                        },
                        {
                            dataType: 'SEND_TYPE',
                            label: '#전송기준#',
                            previewText: '',
                        },
                        {
                            dataType: 'PAYMENT_HISTORY',
                            label: '#결제내역#',
                            previewText: `상품명 -원\n----------------------\n총결제 금액 -원`,
                        },
                        {
                            dataType: 'MILEAGE',
                            label: '#마일리지#',
                        },
                    ];
                    return [..._autoInputWordList, ..._newAutoInputWordList];
                    break;
                case 'CUSTOMER_FIRST_BUY_TICKET_ALARM':
                case 'CUSTOMER_BUY_RENTAL_TICKET_ALARM':
                case 'CUSTOMER_REBUY_TICKET_ALARM':
                    _newAutoInputWordList = [
                        {
                            dataType: 'PRODUCT_NAME',
                            label: '#상품명#',
                            previewText: `'상품명'`,
                        },

                        {
                            dataType: 'PAYMENT_HISTORY',
                            label: '#결제내역#',
                            previewText: `상품명 -원\n----------------------\n총결제 금액 -원`,
                        },
                    ];
                    return [..._autoInputWordList, ..._newAutoInputWordList];
                    break;
                case 'CUSTOMER_BUY_RENTAL_SPORTS_TICKET_ALARM':
                    return [
                        ..._autoInputWordList,
                        {
                            dataType: 'SPORTS_PRODUCT_NAME',
                            label: '#상품명#',
                            previewText: `상품명`,
                        },
                        {
                            dataType: 'PAYMENT_HISTORY',
                            label: '#결제내역#',
                            previewText: `상품명 -원\n----------------------\n총결제 금액 -원`,
                        },
                    ];
                    break;
                case 'CUSTOMER_BUY_RENTAL_LOCKER_TICKET_ALARM':
                    return [
                        ..._autoInputWordList,
                        {
                            dataType: 'LOCKER_PRODUCT_NAME',
                            label: '#상품명#',
                            previewText: `상품명`,
                        },
                        {
                            dataType: 'PAYMENT_HISTORY',
                            label: '#결제내역#',
                            previewText: `상품명 -원\n----------------------\n총결제 금액 -원`,
                        },
                    ];
                    break;
                case 'SPORTS_EXPIRE_ALARM':
                case 'LOCKER_EXPIRE_ALARM':
                case 'SPORTS_EXPIRE_DATE_ALARM':
                case 'RENTAL_EXPIRE_DATE_ALARM':
                case 'LOCKER_EXPIRE_DATE_ALARM':
                    _newAutoInputWordList = [
                        {
                            dataType: 'PRODUCT_NAME',
                            label: '#상품명#',
                            previewText: `'상품명'`,
                        },
                        {
                            dataType: 'SEND_TYPE',
                            label: '#전송기준#',
                            previewText: '',
                        },
                        {
                            dataType: 'EXPIRE_DATE',
                            label: '#만료일#',
                        },
                        {
                            dataType: 'MILEAGE',
                            label: '#마일리지#',
                        },
                    ];
                    return [..._autoInputWordList, ..._newAutoInputWordList];
                    break;

                case 'CUSTOMER_HOLDING_NEW_ALARM':
                case 'CUSTOMER_HOLDING_EXPIRE_ALARM':
                    _newAutoInputWordList = [
                        {
                            dataType: 'PRODUCT_NAME',
                            label: '#상품명#',
                            previewText: `'상품명'`,
                        },
                        {
                            dataType: 'SEND_TYPE',
                            label: '#전송기준#',
                            previewText: '',
                        },
                        {
                            dataType: 'HOLDING_START',
                            label: '#홀딩시작일#',
                            previewText: `xxxx년 xx월 xx일`,
                        },
                        {
                            dataType: 'HOLDING_END',
                            label: '#홀딩종료일#',
                            previewText: `xxxx년 xx월 xx일`,
                        },
                    ];
                    return [..._autoInputWordList, ..._newAutoInputWordList];

                    break;
                case 'CUSTOMER_COUPON_EXPIRE_ALARM':
                    _newAutoInputWordList = [
                        {
                            dataType: 'COUPON_NAME',
                            label: '#쿠폰명#',
                            previewText: `쿠폰명`,
                        },
                        {
                            dataType: 'SEND_TYPE',
                            label: '#전송기준#',
                            previewText: '',
                        },
                        {
                            dataType: 'EXPIRE_DATE',
                            label: '#만료일#',
                            previewText: `YYYY-MM-DD`,
                        },
                    ];
                    return [..._autoInputWordList, ..._newAutoInputWordList];
                    break;

                case 'CUSTOMER_CONTRACT_DONE_ALARM':
                    _newAutoInputWordList = [
                        {
                            dataType: 'CONTRACT_NAME',
                            label: '#계약서명#',
                            previewText: `샘플 계약서`,
                        },
                        {
                            dataType: 'CONTRACT_LINK',
                            label: '#계약서링크#',
                            previewText: `계약서 링크입니다.(링크)`,
                        },
                    ];

                    return [..._autoInputWordList, ..._newAutoInputWordList];
                    break;
                case 'PERIODIC_LOCKER_ASSIGNMENT_ALARM':
                    _newAutoInputWordList = [
                        {
                            dataType: 'LOCKER_ROOM_NAME',
                            label: '#락커룸명#',
                            previewText: '락커룸명',
                        },
                        {
                            dataType: 'LOCKER_NUMBER',
                            label: '#락커번호#',
                            previewText: 'NN',
                        },
                        {
                            dataType: 'LOCKER_START',
                            label: '#락커이용시작시점#',
                            previewText: `YYYY-MM-DD hh:mm`,
                        },
                        {
                            dataType: 'LOCKER_START',
                            label: '#락커이용시작시점#',
                            previewText: `YYYY-MM-DD hh:mm`,
                        },
                        {
                            dataType: 'LOCKER_END',
                            label: '#락커이용만료시점#',
                            previewText: `YYYY-MM-DD hh:mm`,
                        },
                    ];
                    return [..._autoInputWordList, ..._newAutoInputWordList];
                    break;
                case 'SMART_DAILY_LOCKER_ASSIGNMENT':
                    _newAutoInputWordList = [
                        {
                            dataType: 'LOCKER_ROOM_NAME',
                            label: '#락커룸명#',
                            previewText: '락커룸명',
                        },
                        {
                            dataType: 'LOCKER_NUMBER',
                            label: '#락커번호#',
                            previewText: 'NN',
                        },
                        {
                            dataType: 'LOCKER_START',
                            label: '#락커이용시작시점#',
                            previewText: `YYYY-MM-DD hh:mm`,
                        },
                        {
                            dataType: 'LOCKER_END',
                            label: '#락커이용만료시점#',
                            previewText: `YYYY-MM-DD hh:mm`,
                        },
                        {
                            dataType: 'LOCKER_USING_TIME',
                            label: '#락커이용시간#',
                            previewText: 'N',
                        },
                    ];
                    return [..._autoInputWordList, ..._newAutoInputWordList];
                    break;
                case 'LESSON_BOOK_ALARM':
                    _newAutoInputWordList = [
                        {
                            dataType: 'DAILY_RESERVATION_POSSIBLE_COUNT',
                            label: '#일일예약가능횟수#',
                        },
                        {
                            dataType: 'WEEKLY_RESERVATION_POSSIBLE_COUNT',
                            label: '#주간예약가능횟수#',
                        },
                        {
                            dataType: 'MONTHLY_RESERVATION_POSSIBLE_COUNT',
                            label: '#월간예약가능횟수#',
                        },
                        {
                            dataType: 'TOTAL_REMAINING_COUNTS',
                            label: '#총남은횟수#',
                        },
                    ];
                    return [..._lessonInputBaseList, ..._newAutoInputWordList];
                    break;
                case 'FACILITY_BOOK_ALARM':
                    _newAutoInputWordList = [
                        {
                            dataType: 'DAILY_RESERVATION_POSSIBLE_COUNT',
                            label: '#일일예약가능횟수#',
                        },
                        {
                            dataType: 'WEEKLY_RESERVATION_POSSIBLE_COUNT',
                            label: '#주간예약가능횟수#',
                        },
                        {
                            dataType: 'MONTHLY_RESERVATION_POSSIBLE_COUNT',
                            label: '#월간예약가능횟수#',
                        },
                        {
                            dataType: 'TOTAL_REMAINING_COUNTS',
                            label: '#총남은횟수#',
                        },
                        {
                            dataType: 'PRODUCT_USING_TIME',
                            label: '#상품이용기간#',
                        },
                    ];
                    return [
                        ..._facilityInputBaseList,
                        ..._newAutoInputWordList,
                    ];
                    break;
                case 'LESSON_CANCEL_BOOK_ALARM':
                    _newAutoInputWordList = [
                        {
                            dataType: 'TOTAL_REMAINING_COUNTS',
                            label: '#총남은횟수#',
                        },
                    ];
                    return [..._lessonInputBaseList, ..._newAutoInputWordList];
                    break;
                case 'FACILITY_CANCEL_BOOK_ALARM':
                    _newAutoInputWordList = [
                        {
                            dataType: 'TOTAL_REMAINING_COUNTS',
                            label: '#총남은횟수#',
                        },
                        {
                            dataType: 'PRODUCT_USING_TIME',
                            label: '#상품이용기간#',
                        },
                    ];
                    return [
                        ..._facilityInputBaseList,
                        ..._newAutoInputWordList,
                    ];
                    break;
                case 'FACILITY_CHANGE_BOOK_ALARM':
                    _newAutoInputWordList = [
                        {
                            dataType: 'CENTER_NAME',
                            label: '#센터명#',
                        },
                        {
                            dataType: 'MEMBER_NAME',
                            label: '#고객명#',
                        },
                        {
                            dataType: 'FACILITY_NAME',
                            label: '#시설명#',
                        },
                        {
                            dataType: 'SEAT_NAME',
                            label: '#자리명#',
                        },
                        {
                            dataType: 'FACILITY_USING_TIME',
                            label: '#이용일시#',
                        },
                    ];
                    return [..._newAutoInputWordList];
                    break;
                default:
                    break;
            }
        } else {
            return [];
        }
    });
    const [focusedInput, setFocusedInput] = useState(null);
    const [currentMessageType, setCurrentMessageType] = useState('');
    /** selected된 전송 방법 */
    const [selectedMessageTypes, setSelectedMessageTypes] = useState(() => {
        if (isModify && selectedData) {
            return selectedData.auto_message_type_list || [];
        } else {
            return [];
        }
    });
    const [receiverSegmentList, setReceiverSegmentList] = useState([]);
    /** selected된 수신 대상 세그먼트 목록 */
    const [selectedReceiverSegments, setSelectedReceiverSegments] = useState(
        [],
    );
    /** 현재 세그먼트 고객 포함 여부를 안내하는 일회성 확인창 정보. */
    const [initialAudienceConfirmation, setInitialAudienceConfirmation] =
        useState(null);
    const initialAudienceConfirmationResolverRef = useRef(null);
    /** 이용권 / 대여권 만료에만 추가되는 템플릿 옵션 제어 위한 state */
    const [templateOption, setTemplateOption] = useState(() => {
        if (isModify && selectedData) {
            return selectedData?.function_type?.includes('_WITH_MILEAGE')
                ? 'WITH_MILEAGE'
                : 'BASIC';
        } else {
            return 'BASIC';
        }
    });
    const [previewTitle, setPreviewTitle] = useState('');
    const [previewText, setPreviewText] = useState('');
    const [finished, setFinished] = useState(false);
    const [isCreateCompleteModal, setIsCreateCompleteModal] = useState(false);
    const [isModifyCompleteModal, setIsModifyCompleteModal] = useState(false);
    const [cancelModify, setCancelModify] = useState(false);
    const [isPreview, setIsPreview] = useState(false);
    const [isActive, setIsActive] = useState(() => {
        if (isModify && selectedData) {
            if (selectedData.status === 'DISABLED') {
                return false;
            } else {
                return true;
            }
        }
        return true;
    });
    const adInfoRef = useRef();
    const formRef = useRef();
    const autoInputWordRef = useRef();
    const jgroupKey = useSelector(
        (state) => state.groupReducer.jgroup_key_inCookie,
    );
    const [byteValue, setByteValue] = useState(0);

    // 알림톡 체크 되었는지 판단하는 변수
    const isSelectedAlimTalk = useMemo(() => {
        return selectedMessageTypes.includes('KAKAO_ALIM_TALK');
    }, [selectedMessageTypes]);

    // baseType: function_type에서 `_WITH_MILEAGE` 접미사를 제거한 기본 타입
    const baseType = useMemo(() => {
        return stripWithMileage(selectedOption.function_type);
    }, [selectedOption.function_type]);
    const selectedOptionConfig = getAutoMessageOptionConfig(baseType);
    const selectedScheduleConfig = selectedOptionConfig.schedule;

    // effectiveFunctionType: baseType + 현재 선택된 라디오 옵션(templateOption)을 반영한 최종 타입(다만, 알림톡을 선택한 경우에만 유효)
    const effectiveFunctionType = useMemo(() => {
        const finalTmpOption = isSelectedAlimTalk ? templateOption : 'BASIC';
        return getFinalFunctionType(baseType, finalTmpOption);
    }, [baseType, templateOption, isSelectedAlimTalk]);

    // hasDualTemplate: 해당 baseType이 듀얼 템플릿 대상인지 여부
    // (회원권 만료 전/만료 시, 수강권 만료 전/만료 시, 락커 만료, 운동복 만료)
    const hasDualTemplate = useMemo(() => {
        return dualFunctionTypes.includes(baseType);
    }, [baseType]);

    const selectedReceiverSegmentKeys = useMemo(() => {
        return selectedReceiverSegments.map((data) =>
            String(data.segment_key),
        );
    }, [selectedReceiverSegments]);

    useEffect(() => {
        async function setCoupons() {
            const coupons = await getCoupon({
                jgroup_key: jgroupKey,
            });

            // 자동 문자 설정 추가 시 수량이 무제한인 경우와 V2인 쿠폰만 가능하도록 filter
            // 0819 추가) period_type이 "SPECIFIC"(기간으로 특정된 경우)면서 jgcp_period_end < 오늘이라면
            const today = moment();
            const isUsableCoupon = (coupon) => {
                if (!(coupon.version === 'V2' && !coupon.jgcp_limited)) {
                    return false;
                }
                if (coupon.period_type === 'SPECIFIC') {
                    if (!coupon.jgcp_period_end) return false; // 근데 종료일이 없을 수는 없음(예외처리)
                    const endOfDay = moment(coupon.jgcp_period_end).endOf(
                        'day',
                    );
                    return moment(coupon.jgcp_period_end).isSameOrAfter(
                        today,
                        'day',
                    );
                }
                return true;
            };
            let _couponList = coupons.filter(isUsableCoupon);
            _couponList.unshift({
                jgcp_key: -1,
                jgcp_name: '선택 없음',
            });
            // 기존 로직
            // console.log("_couponList", _couponList);
            // let _couponList = coupons.filter(
            //     (coupon) => coupon.version === 'V2' && !coupon.jgcp_limited,
            // );
            setCouponList([..._couponList]);
        }

        setCoupons();
    }, []);

    useEffect(() => {
        async function setSegments() {
            if (!jgroupKey) {
                return;
            }

            try {
                const segments = await getGroupSegments({
                    group_key: jgroupKey,
                    list_type: 'CUSTOMER',
                });

                setReceiverSegmentList(Array.isArray(segments) ? segments : []);
            } catch (e) {
                console.log(e);
                setReceiverSegmentList([]);
            }
        }

        setSegments();
    }, [jgroupKey]);

    useEffect(() => {
        dispatch(getKakaoTemplatesAction());
    }, []);

    useEffect(() => {
        if (
            !isModify ||
            !selectedData ||
            !Array.isArray(selectedData.segment_keys) ||
            receiverSegmentList.length === 0
        ) {
            return;
        }

        const selectedKeys = selectedData.segment_keys.map((data) =>
            String(data),
        );
        const mappedSegments = receiverSegmentList.filter((data) =>
            selectedKeys.includes(String(data.segment_key)),
        );

        setSelectedReceiverSegments(mappedSegments);
    }, [isModify, selectedData, receiverSegmentList]);

    useEffect(() => {
        if (
            couponList &&
            couponList.length > 0 &&
            isModify &&
            selectedData.coupon_parent_key
        ) {
            let _label;
            _label =
                couponList &&
                couponList.length > 0 &&
                couponList.filter(
                    (data) => data.jgcp_key === selectedData.coupon_parent_key,
                );
            setSelectCoupon({
                label: _label.length > 0 ? _label[0].jgcp_name : '',
                coupon_key: selectedData.coupon_parent_key,
            });
        }
    }, [couponList]);

    useEffect(() => {
        const titleByte = getByteLength(messageTitle);
        const bodyByte = getByteLength(messageBody);

        if (titleByte + bodyByte > 90) {
            setCurrentMessageType('LMS');
        } else {
            setCurrentMessageType('SMS');
        }
        if (isAdInformation) {
            const jgroupNameByte = getByteLength(jgroupData?.jgroup_name);
            setByteValue(titleByte + bodyByte + jgroupNameByte + 27);
        } else {
            setByteValue(titleByte + bodyByte);
        }
    }, [messageTitle, messageBody]);

    // useEffect(() => {
    //   if (selectCoupon.coupon_key > 0) {
    //     setIsAdInformation(true);
    //   }
    // }, [selectCoupon]);

    useEffect(() => {
        if (createAutoMessageDone && finished) {
            setIsCreateCompleteModal(true);
        } else if (modifyAutoMessageDone && finished) {
            setIsModifyCompleteModal(true);
        } else if (modifyAutoMessageError && finished) {
            message.destroy();
            message.error({
                // 만약 Reason이 있다면 보여주는 방식으로 바꿔도 됨
                content:
                    '자동알림 설정 수정에 실패했습니다. 문제가 계속 된다면 브로제이에 문의해주세요.',
                style: {
                    marginTop: '90vh',
                },
                duration: 1,
            });
        } else if (createAutoMessageError && finished) {
            message.destroy();
            message.error({
                // 만약 Reason이 있다면 보여주는 방식으로 바꿔도 됨
                content:
                    '자동알림 설정 생성에 실패했습니다. 문제가 계속 된다면 브로제이에 문의해주세요.',
                style: {
                    marginTop: '90vh',
                },
                duration: 1,
            });
        }
    }, [
        createAutoMessageDone,
        modifyAutoMessageDone,
        modifyAutoMessageError,
        createAutoMessageError,
        finished,
    ]);

    useEffect(() => {
        let autoInputWordContainer = autoInputWordRef.current;
        if (autoInputWordContainer) {
            const handleMouseEnter = () => {
                formRef.current.style.overflow = 'hidden';
            };
            const handleMouseLeave = () => {
                formRef.current.style.overflow = 'auto';
            };
            autoInputWordContainer.addEventListener(
                'mouseenter',
                handleMouseEnter,
            );
            autoInputWordContainer.addEventListener(
                'mouseleave',
                handleMouseLeave,
            );
            return () => {
                autoInputWordContainer.removeEventListener(
                    'mouseenter',
                    handleMouseEnter,
                );
                autoInputWordContainer.removeEventListener(
                    'mouseleave',
                    handleMouseLeave,
                );
            };
        }
    });

    /**전송기준, 광고관련 state 변경시 미리보기 변경 되어야함  */
    useEffect(() => {
        let newPreviewTitleText;
        let newPreviewBodyText;
        if (isAdInformation && isPreview) {
            newPreviewTitleText = '(광고)' + previewTitle;
            setPreviewTitle(newPreviewTitleText);
        } else if (!isAdInformation && isPreview) {
            newPreviewTitleText = previewTitle.replace('(광고)', '');
            setPreviewTitle(newPreviewTitleText);
        }

        newPreviewTitleText = handleOnchangePreview(messageTitle);
        newPreviewBodyText = handleOnchangePreview(messageBody);
        setPreviewTitle(newPreviewTitleText);
        setPreviewText(newPreviewBodyText);
    }, [
        scheduleType,
        scheduleTypeList,
        numberType,
        numberTypeList,
        isAdInformation,
    ]);

    /** 알림톡 선택 시 제목 / 내용 입력 되도록 */
    useEffect(() => {
        if (isSelectedAlimTalk && getKakaoAlimTalkTemplatesDone) {
            setIsPreview(false); // 미리보기 초기화
            let kakaoMessageTitle;
            let kakaoMessageBody;

            const match = kakaoAlimTalkTemplates.find(
                (tmp) => tmp.function_type === effectiveFunctionType,
            );

            kakaoMessageTitle = match ? `${match.title}` : '';
            kakaoMessageBody = match ? `${match.body}` : '';
            setMessageTitle(kakaoMessageTitle);
            setMessageBody(kakaoMessageBody);
        }
    }, [
        isSelectedAlimTalk,
        getKakaoAlimTalkTemplatesDone,
        effectiveFunctionType,
    ]);

    /** 미리보기 handler 함수 */
    const handleOnchangePreview = (replaceText) => {
        let scheduleTypeText = '';
        let numberTypeText = '';
        if (scheduleTypeList.length > 0 && scheduleTypeList) {
            scheduleTypeText = `${
                scheduleTypeList[0].dateCount === 0 ||
                scheduleTypeList[0].dateCountTiming === 'EQUAL'
                    ? ''
                    : scheduleTypeList[0].dateCount
            }${
                scheduleTypeList[0].dateCountTiming === 'EQUAL'
                    ? ''
                    : scheduleTypeList[0].dateCountType === 'DAY'
                    ? '일'
                    : '주'
            } ${
                scheduleTypeList[0].dateCountTiming === 'EQUAL' ? '당일' : ''
                // : scheduleTypeList[0].dateCountTiming === "PLUS"
                // ? "후"
                // : "전"
            }`;
        }
        if (numberTypeList && numberTypeList.length > 0) {
            numberTypeText = `${numberTypeList[0].count}회`;
        }
        return replaceText
            .replace(
                /#센터명#/g,
                `${jgroupData.jgroup_name && jgroupData.jgroup_name}`,
            )
            .replace(/#회원명#/g, `${'홍길동'}`)
            .replace(/#고객명#/g, `${'홍길동'}`)
            .replace(/#운톡가입링크#/g, `http://link.broj.co.kr/connect/XXXXXX`)
            .replace(/#상품명#/g, '상품명')
            .replace(
                /#출석시간#/g,
                moment().format('YYYY-MM-DD (ddd) HH:mm:ss'),
            )
            .replace(
                /#전송기준#/g,
                scheduleType && numberType
                    ? `${scheduleTypeText}/${numberTypeText}`
                    : scheduleType
                    ? `${scheduleTypeText}`
                    : `${numberTypeText}`,
            )
            .replace(/#상품명#/g, '락커 6개월 공용락커룸 23번 락커')
            .replace(/#상품명#/g, '운동복 6개월')
            .replace(
                /#결제내역#/g,
                '[상품명] N원', //'상품명 -원\n---------------------------------\n총결제 금액 -원',
            )
            .replace(/#홀딩시작일#/g, 'YYYY-MM-DD')
            .replace(/#홀딩종료일#/g, 'YYYY-MM-DD')
            .replace(/#쿠폰명#/g, '쿠폰명')
            .replace(/#계약서명#/g, '샘플 계약서')
            .replace(/#계약서링크#/g, '계약서 링크입니다.\n(링크)')
            .replace(/#만료일#/g, 'YYYY-MM-DD')
            .replace(/#최종만료일#/g, 'YYYY-MM-DD')
            .replace(/#락커룸명#/g, '락커룸명')
            .replace(/#락커번호#/g, 'NN')
            .replace(/#락커이용시작시점#/g, 'YYYY-MM-DD hh:mm')
            .replace(/#락커이용만료시점#/g, 'YYYY-MM-DD hh:mm')
            .replace(/#락커이용시간#/g, 'N')
            .replace(/#마일리지#/g, 'NN')
            .replace(/#시설명#/g, '시설명')
            .replace(/#자리명#/g, '자리명')
            .replace(/#이용일시#/g, 'YYYY-MM-DD hh:mm ~ hh:mm')
            .replace(/#변경후시설명#/g, '시설명')
            .replace(/#변경후자리명#/g, '자리명')
            .replace(/#변경후이용일시#/g, 'YYYY-MM-DD hh:mm ~ hh:mm')
            .replace(/#상품이용기간#/g, 'YYYY-MM-DD ~ YYYY-MM-DD')
            .replace(/#일일예약가능횟수#/g, 'NN')
            .replace(/#주간예약가능횟수#/g, 'NN')
            .replace(/#월간예약가능횟수#/g, 'NN')
            .replace(/#총남은횟수#/g, 'NN')
            .replace(/#일정명#/g, '수업일정명')
            .replace(/#일정일시#/g, 'YYYY-MM-DD hh:mm ~ hh:mm');
    };

    /** dualTemplateRadio change 함수 */
    const handleDualTemplateRadio = (selectedRadioItem) => {
        const selectedRadioItemValue = selectedRadioItem.target.value;
        setTemplateOption(selectedRadioItemValue);
    };

    /** 현재 focus된 input이 title인지 body인지 */
    const handleFocusInput = (focus) => {
        setFocusedInput(focus);
    };

    /**옵션 dropdown 열고 닫는 함수 */
    const handleIsSelectOption = () => {
        if (isSelectOption) {
            setIsSelectOption(false);
            return;
        }

        if (selectedOption.related) {
            setActiveOptionTab(
                relatedToTabKey[selectedOption.related] || activeOptionTab,
            );
        }

        setIsSelectOption(true);
    };

    const handleSetCancel = () => {
        setCancelModify((cancelModify) => !cancelModify);
    };

    const setAutoInputWordListData = (value) => {
        let _autoInputWordList = [
            {
                dataType: 'CENTER_NAME',
                label: '#센터명#',
                previewText: `${jgroupData.jgroup_name}`,
            },
            {
                dataType: 'MEMBER_NAME',
                label: '#고객명#',
                previewText: '홍길동',
            },
            {
                dataType: 'ONTALK_LINK',
                label: '#운톡가입링크#',
                previewText: `센터의 원활한 사용을 위한 운톡 어플링트를 함께 보내드립니다!(링크)`,
            },
        ];
        const _lessonInputBaseList = [
            {
                dataType: 'CENTER_NAME',
                label: '#센터명#',
            },
            {
                dataType: 'MEMBER_NAME',
                label: '#고객명#',
            },
            {
                dataType: 'PRODUCT_NAME',
                label: '#상품명#',
            },
            {
                dataType: 'PRODUCT_USING_TIME',
                label: '#상품이용기간#',
            },
            {
                dataType: 'LESSON_NAME',
                label: '#일정명#',
            },
            {
                dataType: 'LESSON_DATE',
                label: '#일정일시#',
            },
        ];
        const _facilityInputBaseList = [
            {
                dataType: 'CENTER_NAME',
                label: '#센터명#',
            },
            {
                dataType: 'MEMBER_NAME',
                label: '#고객명#',
            },
            {
                dataType: 'PRODUCT_NAME',
                label: '#상품명#',
            },
            {
                dataType: 'FACILITY_NAME',
                label: '#시설명#',
            },
            {
                dataType: 'SEAT_NAME',
                label: '#자리명#',
            },
            {
                dataType: 'FACILITY_USING_TIME',
                label: '#이용일시#',
            },
        ];
        let _newAutoInputWordList;
        if (
            getAutoMessageOptionConfig(value.function_type)
                .autoInputWordGroup === 'BASE'
        ) {
            setAutoInputWordList([..._autoInputWordList]);
            return;
        }
        switch (value.function_type) {
            case 'NEW_CUSTOMER_CREATED':
            case 'CUSTOMER_BIRTHDAY_ALARM':
            case 'ACTIVE_CUSTOMER_ALARM':
            case 'INACTIVE_CUSTOMER_ALARM':
                setAutoInputWordList([..._autoInputWordList]);
                break;
            case 'CUSTOMER_NON_ATTENDANCE':
                setAutoInputWordList([
                    ..._autoInputWordList,
                    {
                        dataType: 'ATTENDANCE_DATE_TIME',
                        label: '#출석시간#',
                        previewText: `YYYY-MM-DD (ddd) HH:mm:ss`,
                    },
                    {
                        dataType: 'SEND_TYPE',
                        label: '#전송기준#',
                        previewText: '',
                    },
                    {
                        dataType: 'FINAL_EXPIRE_DATE',
                        label: '#최종만료일#',
                    },
                ]);
                break;
            case 'CUSTOMER_ATTENDANCE':
                setAutoInputWordList([
                    ..._autoInputWordList,
                    {
                        dataType: 'ATTENDANCE_DATE_TIME',
                        label: '#출석시간#',
                        previewText: `'yyyy-MM-dd (E) HH:mm:ss'`,
                    },
                ]);
                break;
            case 'MEMBER_TICKET_EXPIRE_ALARM':
            case 'LESSON_TICKET_EXPIRE_ALARM':
            case 'LESSON_PROGRAM_EXPIRE_ALARM':
            case 'RENTAL_PROGRAM_EXPIRE_ALARM':
            case 'FACILITY_TICKET_EXPIRE_ALARM':
            case 'ENTRY_TICKET_EXPIRE_ALARM':
            case 'CLASS_TICKET_EXPIRE_ALARM':
                _newAutoInputWordList = [
                    {
                        dataType: 'PRODUCT_NAME',
                        label: '#상품명#',
                        previewText: `'상품명'`,
                    },
                    {
                        dataType: 'SEND_TYPE',
                        label: '#전송기준#',
                        previewText: '',
                    },
                    {
                        dataType: 'PAYMENT_HISTORY',
                        label: '#결제내역#',
                        previewText: `상품명 -원\n----------------------\n총결제 금액 -원`,
                    },
                    {
                        dataType: 'EXPIRE_DATE',
                        label: '#만료일#',
                    },
                    {
                        dataType: 'MILEAGE',
                        label: '#마일리지#',
                    },
                ];
                setAutoInputWordList([
                    ..._autoInputWordList,
                    ..._newAutoInputWordList,
                ]);
                break;
            case 'MEMBER_TICKET_EXPIRE_DATE_ALARM':
            case 'LESSON_TICKET_EXPIRE_DATE_ALARM':
            case 'LESSON_PROGRAM_EXPIRE_DATE_ALARM':
            case 'RENTAL_PROGRAM_EXPIRE_DATE_ALARM':
            case 'FACILITY_TICKET_EXPIRE_DATE_ALARM':
            case 'ENTRY_TICKET_EXPIRE_DATE_ALARM':
            case 'CLASS_TICKET_EXPIRE_DATE_ALARM':
                _newAutoInputWordList = [
                    {
                        dataType: 'PRODUCT_NAME',
                        label: '#상품명#',
                        previewText: `'상품명'`,
                    },
                    {
                        dataType: 'SEND_TYPE',
                        label: '#전송기준#',
                        previewText: '',
                    },
                    {
                        dataType: 'PAYMENT_HISTORY',
                        label: '#결제내역#',
                        previewText: `상품명 -원\n----------------------\n총결제 금액 -원`,
                    },
                    {
                        dataType: 'MILEAGE',
                        label: '#마일리지#',
                    },
                ];
                setAutoInputWordList([
                    ..._autoInputWordList,
                    ..._newAutoInputWordList,
                ]);
                break;
            case 'CUSTOMER_FIRST_BUY_TICKET_ALARM':
            case 'CUSTOMER_BUY_RENTAL_TICKET_ALARM':
            case 'CUSTOMER_REBUY_TICKET_ALARM':
                _newAutoInputWordList = [
                    {
                        dataType: 'PRODUCT_NAME',
                        label: '#상품명#',
                        previewText: `'상품명'`,
                    },

                    {
                        dataType: 'PAYMENT_HISTORY',
                        label: '#결제내역#',
                        previewText: `상품명 -원\n----------------------\n총결제 금액 -원`,
                    },
                ];
                setAutoInputWordList([
                    ..._autoInputWordList,
                    ..._newAutoInputWordList,
                ]);
                break;
            case 'CUSTOMER_BUY_RENTAL_SPORTS_TICKET_ALARM':
                setAutoInputWordList([
                    ..._autoInputWordList,
                    {
                        dataType: 'SPORTS_PRODUCT_NAME',
                        label: '#상품명#',
                        previewText: `상품명`,
                    },
                    {
                        dataType: 'PAYMENT_HISTORY',
                        label: '#결제내역#',
                        previewText: `상품명 -원\n----------------------\n총결제 금액 -원`,
                    },
                ]);
                break;
            case 'CUSTOMER_BUY_RENTAL_LOCKER_TICKET_ALARM':
                setAutoInputWordList([
                    ..._autoInputWordList,
                    {
                        dataType: 'LOCKER_PRODUCT_NAME',
                        label: '#상품명#',
                        previewText: `상품명`,
                    },
                    {
                        dataType: 'PAYMENT_HISTORY',
                        label: '#결제내역#',
                        previewText: `상품명 -원\n----------------------\n총결제 금액 -원`,
                    },
                ]);
                break;
            case 'SPORTS_EXPIRE_ALARM':
            case 'LOCKER_EXPIRE_ALARM':
            case 'SPORTS_EXPIRE_DATE_ALARM':
            case 'RENTAL_EXPIRE_DATE_ALARM':
            case 'LOCKER_EXPIRE_DATE_ALARM':
                _newAutoInputWordList = [
                    {
                        dataType: 'PRODUCT_NAME',
                        label: '#상품명#',
                        previewText: `'상품명'`,
                    },
                    {
                        dataType: 'SEND_TYPE',
                        label: '#전송기준#',
                        previewText: '',
                    },
                    {
                        dataType: 'EXPIRE_DATE',
                        label: '#만료일#',
                    },
                    {
                        dataType: 'MILEAGE',
                        label: '#마일리지#',
                    },
                ];
                setAutoInputWordList([
                    ..._autoInputWordList,
                    ..._newAutoInputWordList,
                ]);
                break;

            case 'CUSTOMER_HOLDING_NEW_ALARM':
            case 'CUSTOMER_HOLDING_EXPIRE_ALARM':
                _newAutoInputWordList = [
                    {
                        dataType: 'PRODUCT_NAME',
                        label: '#상품명#',
                        previewText: `'상품명'`,
                    },
                    {
                        dataType: 'SEND_TYPE',
                        label: '#전송기준#',
                        previewText: '',
                    },
                    {
                        dataType: 'HOLDING_START',
                        label: '#홀딩시작일#',
                        previewText: `xxxx년 xx월 xx일`,
                    },
                    {
                        dataType: 'HOLDING_END',
                        label: '#홀딩종료일#',
                        previewText: `xxxx년 xx월 xx일`,
                    },
                ];
                setAutoInputWordList([
                    ..._autoInputWordList,
                    ..._newAutoInputWordList,
                ]);
                break;
            case 'CUSTOMER_COUPON_EXPIRE_ALARM':
                _newAutoInputWordList = [
                    {
                        dataType: 'COUPON_NAME',
                        label: '#쿠폰명#',
                        previewText: `쿠폰명`,
                    },
                    {
                        dataType: 'SEND_TYPE',
                        label: '#전송기준#',
                        previewText: '',
                    },
                    {
                        dataType: 'EXPIRE_DATE',
                        label: '#만료일#',
                        previewText: `YYYY-MM-DD`,
                    },
                ];
                setAutoInputWordList([
                    ..._autoInputWordList,
                    ..._newAutoInputWordList,
                ]);
                break;

            case 'CUSTOMER_CONTRACT_DONE_ALARM':
                _newAutoInputWordList = [
                    {
                        dataType: 'CONTRACT_NAME',
                        label: '#계약서명#',
                        previewText: `샘플 계약서`,
                    },
                    {
                        dataType: 'CONTRACT_LINK',
                        label: '#계약서링크#',
                        previewText: `계약서 링크입니다.(링크)`,
                    },
                ];
                setAutoInputWordList([
                    ..._autoInputWordList,
                    ..._newAutoInputWordList,
                ]);
                break;
            case 'PERIODIC_LOCKER_ASSIGNMENT_ALARM':
                _newAutoInputWordList = [
                    {
                        dataType: 'LOCKER_ROOM_NAME',
                        label: '#락커룸명#',
                        previewText: '락커룸명',
                    },
                    {
                        dataType: 'LOCKER_NUMBER',
                        label: '#락커번호#',
                        previewText: 'NN',
                    },
                    {
                        dataType: 'LOCKER_START',
                        label: '#락커이용시작시점#',
                        previewText: `YYYY-MM-DD hh:mm`,
                    },
                    {
                        dataType: 'LOCKER_END',
                        label: '#락커이용만료시점#',
                        previewText: `YYYY-MM-DD hh:mm`,
                    },
                ];
                setAutoInputWordList([
                    ..._autoInputWordList,
                    ..._newAutoInputWordList,
                ]);
                break;
            case 'SMART_DAILY_LOCKER_ASSIGNMENT':
                _newAutoInputWordList = [
                    {
                        dataType: 'LOCKER_ROOM_NAME',
                        label: '#락커룸명#',
                        previewText: '락커룸명',
                    },
                    {
                        dataType: 'LOCKER_NUMBER',
                        label: '#락커번호#',
                        previewText: 'NN',
                    },
                    {
                        dataType: 'LOCKER_START',
                        label: '#락커이용시작시점#',
                        previewText: `YYYY-MM-DD hh:mm`,
                    },
                    {
                        dataType: 'LOCKER_END',
                        label: '#락커이용만료시점#',
                        previewText: `YYYY-MM-DD hh:mm`,
                    },
                    {
                        dataType: 'LOCKER_USING_TIME',
                        label: '#락커이용시간#',
                        previewText: 'N',
                    },
                ];
                setAutoInputWordList([
                    ..._autoInputWordList,
                    ..._newAutoInputWordList,
                ]);
                break;
            case 'LESSON_BOOK_ALARM':
                _newAutoInputWordList = [
                    {
                        dataType: 'DAILY_RESERVATION_POSSIBLE_COUNT',
                        label: '#일일예약가능횟수#',
                    },
                    {
                        dataType: 'WEEKLY_RESERVATION_POSSIBLE_COUNT',
                        label: '#주간예약가능횟수#',
                    },
                    {
                        dataType: 'MONTHLY_RESERVATION_POSSIBLE_COUNT',
                        label: '#월간예약가능횟수#',
                    },
                    {
                        dataType: 'TOTAL_REMAINING_COUNTS',
                        label: '#총남은횟수#',
                    },
                ];
                setAutoInputWordList([
                    ..._lessonInputBaseList,
                    ..._newAutoInputWordList,
                ]);
                break;
            case 'FACILITY_BOOK_ALARM':
                _newAutoInputWordList = [
                    {
                        dataType: 'DAILY_RESERVATION_POSSIBLE_COUNT',
                        label: '#일일예약가능횟수#',
                    },
                    {
                        dataType: 'WEEKLY_RESERVATION_POSSIBLE_COUNT',
                        label: '#주간예약가능횟수#',
                    },
                    {
                        dataType: 'MONTHLY_RESERVATION_POSSIBLE_COUNT',
                        label: '#월간예약가능횟수#',
                    },
                    {
                        dataType: 'TOTAL_REMAINING_COUNTS',
                        label: '#총남은횟수#',
                    },
                    {
                        dataType: 'PRODUCT_USING_TIME',
                        label: '#상품이용기간#',
                    },
                ];
                setAutoInputWordList([
                    ..._facilityInputBaseList,
                    ..._newAutoInputWordList,
                ]);
                break;
            case 'LESSON_CANCEL_BOOK_ALARM':
                _newAutoInputWordList = [
                    {
                        dataType: 'TOTAL_REMAINING_COUNTS',
                        label: '#총남은횟수#',
                    },
                ];
                setAutoInputWordList([
                    ..._lessonInputBaseList,
                    ..._newAutoInputWordList,
                ]);
                break;
            case 'FACILITY_CANCEL_BOOK_ALARM':
                _newAutoInputWordList = [
                    {
                        dataType: 'TOTAL_REMAINING_COUNTS',
                        label: '#총남은횟수#',
                    },
                    {
                        dataType: 'PRODUCT_USING_TIME',
                        label: '#상품이용기간#',
                    },
                ];
                setAutoInputWordList([
                    ..._facilityInputBaseList,
                    ..._newAutoInputWordList,
                ]);
                break;
            case 'FACILITY_CHANGE_BOOK_ALARM':
                _newAutoInputWordList = [
                    {
                        dataType: 'CENTER_NAME',
                        label: '#센터명#',
                    },
                    {
                        dataType: 'MEMBER_NAME',
                        label: '#고객명#',
                    },
                    {
                        dataType: 'FACILITY_NAME',
                        label: '#시설명#',
                    },
                    {
                        dataType: 'SEAT_NAME',
                        label: '#자리명#',
                    },
                    {
                        dataType: 'FACILITY_USING_TIME',
                        label: '#이용일시#',
                    },
                ];
                setAutoInputWordList([..._newAutoInputWordList]);
                break;
            default:
                break;
        }
    };

    /**옵션 선택시 onclick 핸들러 함수 */
    const handleSelectOptionBtn = (value) => {
        // console.log("value", value);
        let _selectedOption = {
            label: value.label,
            function_type: value.function_type,
            related: value.related,
            send_time_type: value.send_time_type,
            send_time_types: getSendTimeTypes(value),
        };

        setActiveOptionTab(relatedToTabKey[value.related] || '1');

        let _scheduleTypeList = {
            dateCount: 0,
            dateCountType: '',
            dateCountTiming: '',
            dateCountTimingType: '',
            sendHour: '',
            sendMinute: '',
        };

        let _numberTypeList = {
            count: 0,
        };
        const optionConfig = getAutoMessageOptionConfig(value.function_type);
        const scheduleConfig = optionConfig.schedule;

        setSelectedOption({ ..._selectedOption });
        setAutoMessageName(value.label);
        setSelectedMessageTypes([...optionConfig.messageTypes.default]);
        setSelectedReceiverSegments([]);
        // setMessageTitle("안녕하세요 #센터명# 입니다.");

        if (value.send_time_type === 'IMMEDIATELY') {
            setImmediatelyType(true);
            setScheduleType(false);
            setNumberType(false);
            setIsSelectOption(false);
        } else if (value.send_time_type === 'RELATIVELY_TIME') {
            if (value.function_type === 'LESSON_TICKET_EXPIRE_ALARM') {
                setNumberType(true);
                setScheduleType(false);
                setImmediatelyType(false);
                _numberTypeList.count = 5;
                setNumberTypeList([_numberTypeList]);
            } else {
                setScheduleType(true);
                setImmediatelyType(false);
                setNumberType(false);
                _scheduleTypeList.dateCount = scheduleConfig.defaultCount;
                _scheduleTypeList.dateCountType =
                    scheduleConfig.defaultUnit;
                _scheduleTypeList.dateCountTiming =
                    scheduleConfig.defaultTiming;
                _scheduleTypeList.dateCountTimingType =
                    scheduleConfig.defaultTimingType;
                _scheduleTypeList.sendHour = 10;
                _scheduleTypeList.sendMinute = 0;

                setScheduleTypeList([_scheduleTypeList]);
            }

            setIsSelectOption(false);
        }
        setAutoInputWordListData(value);
        setCurrentMessageType('SMS');
        setMessageBody('');
        setMessageTitle('');
        setSelectCoupon({});
        setIsAdInformation(false);
        setIsPreview(false);
    };

    /**자동 문자명 onChange 핸들러 */
    const handleNameChange = (e) => {
        setAutoMessageName(e.target.value);
    };

    const openAdInfoModal = () => {
        setIsInfoClicked(!isInfoClicked);
    };

    // message.config({
    //   // top: 100,
    //   duration: 10,
    //   // maxCount: 10,
    // });
    /**자동 알림 제목 handler 함수*/
    const handleMessageTitle = (e) => {
        if (isPreview) {
            message.warning({
                content: '미리 보기 시에는 메세지 입력이 불가능합니다.',
                style: {
                    marginTop: '90vh',
                },
                duration: 1,
            });
            return;
        }
        if (e.target.value.includes(`'`) || e.target.value.includes(`"`)) {
            return;
        }
        // 2000 byte 제한을 위한 체크 로직
        const totalByte = getTotalByte({
            title: e.target.value,
            body: messageBody,
        });

        if (totalByte > MAX_BYTES) {
            const trimmedTitle = sliceUntilByteLimit({
                title: e.target.value,
                body: messageBody,
                type: 'TITLE',
            });
            setCursorPosition(e.target.selectionStart);
            setMessageTitle(trimmedTitle);
            showMaxValidMessage();
            return;
        }
        setCursorPosition(e.target.selectionStart);
        setMessageTitle(e.target.value);
    };

    /**자동 알림 내용(body) handler 함수*/
    const handleMessageBody = (e) => {
        if (isPreview) {
            message.warning({
                content: '미리 보기 시에는 메세지 입력이 불가능합니다.',
                style: {
                    marginTop: '90vh',
                },
                duration: 1,
            });
            return;
        }
        if (e.target.value.includes(`'`) || e.target.value.includes(`"`)) {
            return;
        }
        // 2000 byte 제한을 위한 체크 로직
        const totalByte = getTotalByte({
            title: messageTitle,
            body: e.target.value,
        });

        if (totalByte > MAX_BYTES) {
            if (totalByte > MAX_BYTES) {
                const trimmedBody = sliceUntilByteLimit({
                    title: messageTitle,
                    body: e.target.value,
                    type: 'BODY',
                });
                setCursorPosition(e.target.selectionStart);
                setMessageBody(trimmedBody);
                showMaxValidMessage();
                return;
            }
            // showMaxValidMessage();
            // return;
        }

        setCursorPosition(e.target.selectionStart);
        setMessageBody(e.target.value);
    };

    /**전송기준-> 즉시 checkbox 클릭시*/
    const handleImmediatelyTypeChange = (e) => {
        setImmediatelyType(e.target.checked);
    };

    /**전송기준-> 일정 기준 checkbox 클릭시*/
    const handleSchduleTypeChange = (e) => {
        if (
            !numberType &&
            !e.target.checked &&
            (!selectedScheduleConfig.canDisable ||
                numberEnabledFunctionTypes.includes(
                    selectedOption.function_type,
                ))
        ) {
            return;
        }
        if (!e.target.checked) {
            setScheduleTypeList([]);
        } else if (e.target.checked) {
            const scheduleConfig = getAutoMessageOptionConfig(
                selectedOption.function_type,
            ).schedule;
            let newList = [
                {
                    dateCount: scheduleConfig.defaultCount,
                    dateCountType: scheduleConfig.defaultUnit,
                    dateCountTiming: scheduleConfig.defaultTiming,
                    dateCountTimingType: scheduleConfig.defaultTimingType,
                    sendHour: 10,
                    sendMinute: 0,
                },
            ];
            setScheduleTypeList([...newList]);
        }
        setScheduleType(e.target.checked);
    };

    /**전송기준-> 횟수 기준 checkbox 클릭시*/
    const handleNumberTypeChange = (e) => {
        if (
            !scheduleType &&
            !e.target.checked &&
            numberEnabledFunctionTypes.includes(selectedOption.function_type)
        ) {
            return;
        }
        if (e.target.checked) {
            const _numberTypeList = {
                count: 5,
            };

            setNumberTypeList([_numberTypeList]);
        } else if (!e.target.checked) {
            setNumberTypeList([]);
        }

        setNumberType(e.target.checked);
    };

    /**전송기준 -> 일정 기준 -> date Input 값 handler 함수 */
    const handleDateCountChange = (e, idx) => {
        if (isNaN(e.target.value)) {
            return;
        }
        const scheduleConfig = getAutoMessageOptionConfig(
            selectedOption.function_type,
        ).schedule;
        if (
            e.target.value === '' &&
            scheduleConfig.minCount > 0
        ) {
            return;
        }
        if (
            scheduleConfig.maxCount !== null &&
            (Number(e.target.value) < scheduleConfig.minCount ||
                Number(e.target.value) > scheduleConfig.maxCount)
        ) {
            return;
        }
        if (e.target.value === '0' || e.target.value === '') {
            let _scheduleTypeList = scheduleTypeList;
            if (scheduleConfig.allowedTimings.includes('EQUAL')) {
                _scheduleTypeList[idx].dateCountTiming = 'EQUAL';
            }
            _scheduleTypeList[idx].dateCount = Number(e.target.value);
            setScheduleTypeList([..._scheduleTypeList]);
            return;
        }

        const _newScheduletypeList = scheduleTypeList;
        _newScheduletypeList[idx].dateCount = Number(e.target.value);
        setScheduleTypeList([..._newScheduletypeList]);
    };

    /**전송기준 -> 일정 기준 -> 일or주 값 handler 함수 */
    const handleDateCountTypeChange = (e, idx) => {
        const _newScheduletypeList = scheduleTypeList;
        if (e.key === 'day') {
            _newScheduletypeList[idx].dateCountType = 'DAY';
            setScheduleTypeList([..._newScheduletypeList]);
            // setDateCountType("DAY");
        } else {
            _newScheduletypeList[idx].dateCountType = 'WEEK';
            setScheduleTypeList([..._newScheduletypeList]);
            // setDateCountType("WEEK");
        }
    };

    /**전송기준 -> 일정 기준 -> 알림 보내는 타이밍 값 handler 함수 */
    const handleDateCountTimingChange = (e, idx) => {
        // console.log(e);
        // console.log(idx);
        const _newScheduletypeList = scheduleTypeList;
        const scheduleConfig = getAutoMessageOptionConfig(
            selectedOption.function_type,
        ).schedule;
        if (!scheduleConfig.allowedTimings.includes(e.key.toUpperCase())) {
            return;
        }
        if (e.key === 'minus') {
            // console.log("전");
            _newScheduletypeList[idx].dateCountTiming = 'MINUS';
            // if (_newScheduletypeList.length > 1) {

            //   _newScheduletypeList[idx].dateCount =
            //     _newScheduletypeList[idx - 1].dateCount + 7;
            // } else {
            //   _newScheduletypeList[idx].dateCount = 7;
            // }
            setScheduleTypeList([..._newScheduletypeList]);
            // setDateCountTiming("MINUS");
        } else if (e.key === 'plus') {
            // console.log("후");
            _newScheduletypeList[idx].dateCountTiming = 'PLUS';
            _newScheduletypeList[idx].dateCount = Math.max(
                Number(_newScheduletypeList[idx].dateCount) || 0,
                1,
            );
            // if (_newScheduletypeList.length > 1) {
            //   _newScheduletypeList[idx].dateCount =
            //     _newScheduletypeList[idx - 1].dateCount + 7;
            // } else {
            //   _newScheduletypeList[idx].dateCount = 7;
            // }
            setScheduleTypeList([..._newScheduletypeList]);
            // setDateCountTiming("PLUS");
        } else if (e.key === 'equal') {
            // console.log("당일");
            _newScheduletypeList[idx].dateCountTiming = 'EQUAL';
            _newScheduletypeList[idx].dateCount = 0;
            setScheduleTypeList([..._newScheduletypeList]);
            // setDateCountTiming("EQUAL");
        }
    };
    /**전송기준 -> 일정 기준 -> 시간 계산(오전,오후) handler 함수 */
    const hangleDateCountTimingTypeChange = (e, idx) => {
        const _newScheduletypeList = scheduleTypeList;
        if (e.key === 'afternoon') {
            _newScheduletypeList[idx].dateCountTimingType = 'AFTERNOON';
            setScheduleTypeList([..._newScheduletypeList]);
            // setDateCountTimingType("AFTERNOON");
        } else {
            _newScheduletypeList[idx].dateCountTimingType = 'MORNING';
            setScheduleTypeList([..._newScheduletypeList]);
            // setDateCountTimingType("MORNING");
        }
    };

    /**전송기준 -> 일정 기준 -> 시간(hour) handler 함수 */
    const handleSendHourChange = (e, idx) => {
        const _newScheduletypeList = scheduleTypeList;
        if (
            isNaN(e.target.value) ||
            Number(e.target.value) > 12
            // Number(e.target.value) === 0
            // e.target.value > ""
        ) {
            return;
        }
        _newScheduletypeList[idx].sendHour = Number(e.target.value);
        // setSendHour(e.target.value);
        setScheduleTypeList([..._newScheduletypeList]);
    };

    const handleSendMinuteChange = (e, idx) => {
        const _newScheduletypeList = scheduleTypeList;
        if (isNaN(e.target.value) || Number(e.target.value) > 59) {
            return;
        }
        _newScheduletypeList[idx].sendMinute = Number(e.target.value);
        // setSendHour(e.target.value);
        setScheduleTypeList([..._newScheduletypeList]);
    };

    /**일정 기준에서 전송시간 추가 버튼 handler 함수 */
    const addScheduleTypeList = () => {
        const newScheduleType = {
            dateCount:
                Number(
                    scheduleTypeList[scheduleTypeList.length - 1].dateCount,
                ) + 7,
            dateCountType:
                scheduleTypeList[scheduleTypeList.length - 1].dateCountType,
            dateCountTiming:
                scheduleTypeList[scheduleTypeList.length - 1].dateCountTiming,
            dateCountTimingType:
                scheduleTypeList[scheduleTypeList.length - 1]
                    .dateCountTimingType,
            sendHour: scheduleTypeList[scheduleTypeList.length - 1].sendHour,
            sendMinute:
                scheduleTypeList[scheduleTypeList.length - 1].sendMinute,
        };
        setScheduleTypeList((prev) => [...prev, newScheduleType]);
    };

    const openInfoModal = () => {
        setIsInfoClicked(!isInfoClicked);
    };
    /** 횟수 기준에서 전송시간 추가 버튼 handler 함수 */
    const addNumverTypeList = () => {
        const newNumberType = {
            count: Number(numberTypeList[numberTypeList.length - 1].count) + 5,
        };
        setNumberTypeList((prev) => [...prev, newNumberType]);
    };

    /**장기 미출석 선택시 뜨는 모달 close 함수 */
    // const closeIsCustomerNonAttendanceModal = () => {
    //   setIsCustomerNonAttendanceModal(false);
    // };

    /**전송기준에서 횟수기준일 때 count handler 함수*/
    const handleCountChange = (e, idx) => {
        if (isNaN(e.target.value)) {
            return;
        }
        const _newNumberTypeList = numberTypeList;
        _newNumberTypeList[idx].count = Number(e.target.value);
        setNumberTypeList([..._newNumberTypeList]);
    };

    /**쿠폰 선택 handler 함수 */
    const handleSelectCoupon = (e) => {
        const selectedCoupon = couponList.filter(
            (data) => data.jgcp_key == e.key,
        );
        const newSelectedCoupon = {
            label: selectedCoupon[0].jgcp_name,
            coupon_key: e.key,
        };

        setSelectCoupon({ ...newSelectedCoupon });

        // if (e.key == -1) {
        //   let _newMessageTitle = messageTitle.replace("(광고)", "");
        //   setMessageTitle(_newMessageTitle);
        //   setIsAdInformation(false);
        //   return;
        // } else if (e.key > 0) {
        // setIsAdInformation(true);
        // }
        // setMessageTitle("(광고)");
    };

    /**수신 대상 세그먼트 선택 handler 함수 */
    const handleSelectReceiverSegment = (e) => {
        const selectedSegment = receiverSegmentList.find(
            (data) => String(data.segment_key) === String(e.key),
        );

        if (
            !selectedSegment ||
            selectedReceiverSegmentKeys.includes(String(e.key)) ||
            selectedReceiverSegments.length >=
                selectedOptionConfig.receiverSegmentLimit
        ) {
            return;
        }

        setSelectedReceiverSegments((prev) => [...prev, selectedSegment]);
    };

    const handleRemoveReceiverSegment = (segmentKey) => {
        setSelectedReceiverSegments((prev) =>
            prev.filter((data) => data.segment_key !== segmentKey),
        );
    };

    /**광고성 정보 동의 handler 함수 */
    const handleAdInfoChange = (e) => {
        // if (selectCoupon.coupon_key > 0) {
        //   return;
        // }
        // setIsAdInformation(e.target.checked);
        let adInfoText;
        if (e.target.checked) {
            adInfoText = `(광고)${messageTitle ? messageTitle : ''}`;
            // 2000 byte 제한을 위한 체크 로직
            const totalByte = getTotalByte({
                title: adInfoText,
                body: messageBody,
            });
            if (totalByte > MAX_BYTES) {
                showMaxValidMessage();
                return;
            }
            setIsAdInformation(e.target.checked);
            setMessageTitle(adInfoText);
        } else {
            setIsAdInformation(e.target.checked);
            const bodyByte = getByteLength(messageBody);
            adInfoText = `${
                messageTitle ? messageTitle.slice(4, messageTitle.length) : ''
            }`;
            setMessageTitle(adInfoText);
            if (messageTitle.length < 1) {
                setByteValue(bodyByte);
            }
        }
    };

    /**자동 입력 문구 버튼 handler 함수 */
    const handleClickAutoMessageWord = (e, data) => {
        if (isPreview) {
            message.warning({
                content: '미리 보기 시에는 메세지 입력이 불가능합니다.',
                style: {
                    marginTop: '90vh',
                },
                duration: 1,
            });
            return;
        }
        e.preventDefault();
        if (cursorPosition !== null) {
            let newMessageText = '';
            if (focusedInput === 'title') {
                newMessageText = `${messageTitle.slice(0, cursorPosition)}${
                    data.label
                }${messageTitle.slice(cursorPosition)}`;
                // 2000 byte 제한을 위한 체크 로직
                const totalByte = getTotalByte({
                    title: newMessageText,
                    body: messageBody,
                });

                if (totalByte > MAX_BYTES) {
                    showMaxValidMessage();
                    return;
                }
                setMessageTitle(newMessageText);
                formRefs.current.setFieldsValue({
                    body: newMessageText,
                });
            } else {
                newMessageText = `${messageBody.slice(0, cursorPosition)}${
                    data.label
                }${messageBody.slice(cursorPosition)}`;
                // 2000 byte 제한을 위한 체크 로직
                const totalByte = getTotalByte({
                    title: messageTitle,
                    body: newMessageText,
                });

                if (totalByte > MAX_BYTES) {
                    showMaxValidMessage();
                    return;
                }
                setMessageBody(newMessageText);
                formRefs.current.setFieldsValue({
                    body: newMessageText,
                });
            }
            // setTitle(newValue);

            setCursorPosition(cursorPosition + data.label.length);
            // #상품명# 길이만큼 커서 위치 조정
        }
    };

    /** 전송 방법 handler 함수 */
    const handleChangeMessageTypes = (checkedValues) => {
        // 스마트 전송이 선택되었을 경우, 문자메세지 / 운톡 푸쉬 알림 disabled, 선택 해제
        if (checkedValues.includes('SMART_PUSH')) {
            const onlyAllowed = checkedValues.includes('KAKAO_ALIM_TALK')
                ? ['SMART_PUSH', 'KAKAO_ALIM_TALK']
                : ['SMART_PUSH'];
            setSelectedMessageTypes(onlyAllowed);
        } else {
            setSelectedMessageTypes(checkedValues);
        }

        // 알림톡 체크 시, 광고성 정보 체크 해제
        if (checkedValues.includes('KAKAO_ALIM_TALK')) {
            setIsAdInformation(false);
        }
    };

    /**byte 계산 함수 */
    const getByteLength = (str) => {
        let byte = 0;
        for (let i = 0; i < str.length; i++) {
            const code = str.charCodeAt(i);
            if (code > 127) {
                byte += 2;
            } else {
                byte += 1;
            }
        }
        return byte;
    };
    /** 2000자 제한을 위한 title, body, 광고성 정보 byte 총합 구하는 함수 */
    const getTotalByte = ({ title, body }) => {
        const bodyByte = getByteLength(body);
        const titleByte = getByteLength(title);
        const adByte = isAdInformation
            ? getByteLength(jgroupData?.jgroup_name || '') + 27
            : 0;
        const totalByte = bodyByte + titleByte + adByte;
        return totalByte;
    };

    /* 복붙해도 byte 제한까지는 입력되도록 하는 함수 */
    const sliceUntilByteLimit = ({ title, body, type }) => {
        let result = '';
        const adByte = isAdInformation
            ? getByteLength(jgroupData?.jgroup_name || '') + 27
            : 0;

        let maxByte = 0;
        if (type === 'BODY') {
            const titleByte = getByteLength(title);
            maxByte = MAX_BYTES - titleByte - adByte;
        } else {
            const bodyByte = getByteLength(body);
            maxByte = MAX_BYTES - bodyByte - adByte;
        }

        let total = 0;
        const target = type === 'BODY' ? body : title;

        for (let i = 0; i < target.length; i++) {
            const char = target[i];
            const charByte = getByteLength(char);
            if (total + charByte > maxByte) break;
            result += char;
            total += charByte;
        }

        return result;
    };

    /** 2000자 제한 message */
    const showMaxValidMessage = () => {
        message.destroy();
        message.error({
            content: `최대 ${MAX_BYTES}Byte까지 입력 가능합니다`,
            style: {
                marginTop: '90vh',
            },
            duration: 1,
        });
    };

    /** 현재 세그먼트 고객이 발송 대상에 포함됨을 확인받는다. */
    const requestInitialAudienceConfirmation = (memberCount) =>
        new Promise((resolve) => {
            initialAudienceConfirmationResolverRef.current = resolve;
            setInitialAudienceConfirmation({ memberCount });
        });

    /** 현재 고객 포함 확인창을 닫고 확인 결과를 대기 중인 저장 로직에 전달한다. */
    const resolveInitialAudienceConfirmation = (confirmed) => {
        const resolve = initialAudienceConfirmationResolverRef.current;
        initialAudienceConfirmationResolverRef.current = null;
        setInitialAudienceConfirmation(null);
        resolve?.(confirmed);
    };

    /** 현재 저장으로 새 추적 상태가 생성되어 고객 포함 확인이 필요한지 판단한다. */
    const shouldConfirmInitialAudience = () => {
        if (!selectedOptionConfig.initialAudienceConfirmation || !isActive) {
            return false;
        }
        if (!isModify || !selectedData) {
            return true;
        }

        const previousSegmentKeys = (selectedData.segment_keys || [])
            .map(String)
            .sort();
        const currentSegmentKeys = selectedReceiverSegments
            .map((segment) => String(segment.segment_key))
            .sort();
        const segmentChanged =
            previousSegmentKeys.length !== currentSegmentKeys.length ||
            previousSegmentKeys.some(
                (segmentKey, index) =>
                    segmentKey !== currentSegmentKeys[index],
            );

        return (
            (selectedData.status !== 'ENABLED' &&
                selectedOptionConfig.initialAudienceConfirmation
                    .promptOnReactivation) ||
            stripWithMileage(selectedData.function_type) !== baseType ||
            segmentChanged
        );
    };

    const onFinish = async () => {
        if (selectedOption.function_type.length <= 0) {
            message.warning({
                content: '미리 보기 시에는 메세지 입력이 불가능합니다.',
                style: {
                    marginTop: '90vh',
                },
                duration: 1,
            });
            return;
        }
        if (autoMessageName.length <= 0) {
            message.warning({
                content: '자동알림명을 입력해 주세요.',
                style: {
                    marginTop: '90vh',
                },
                duration: 1,
            });
            return;
        }
        // 전송 기준 세개 다 없는지 판단하는 유효성 검사 추가
        if (!immediatelyType && !scheduleType && !numberType) {
            message.warning({
                content: '전송 기준을 선택해 주세요.',
                style: {
                    marginTop: '90vh',
                },
                duration: 1,
            });
            return;
        }
        // if (selectedOption.send_time_type === 'IMMEDIATELY') {
        //     if (!immediatelyType) {
        //         message.warning({
        //             content: '전송 기준을 선택해 주세요.',
        //             style: {
        //                 marginTop: '90vh',
        //             },
        //             duration: 1,
        //         });
        //         return;
        //     }
        // }
        if (selectedMessageTypes.length === 0) {
            message.warning({
                content: '전송 방법을 선택해 주세요.',
                style: {
                    marginTop: '90vh',
                },
                duration: 1,
            });
            return;
        }
        if (messageTitle.length <= 0) {
            message.warning({
                content: '메시지 제목을 입력해 주세요.',
                style: {
                    marginTop: '90vh',
                },
                duration: 1,
            });
            return;
        }
        if (messageBody.length <= 0) {
            message.warning({
                content: '메시지 내용을 입력해 주세요.',
                style: {
                    marginTop: '90vh',
                },
                duration: 1,
            });
            return;
        }
        // 2000자 제한
        if (byteValue > MAX_BYTES) {
            showMaxValidMessage();
            return;
        }

        if (
            selectedOptionConfig.initialAudienceConfirmation &&
            selectedReceiverSegments.length !== 1
        ) {
            message.warning({
                content: '세그먼트 인입 자동알림은 세그먼트 1개를 선택해야 합니다.',
                style: { marginTop: '90vh' },
                duration: 2,
            });
            return;
        }

        if (
            selectedOptionConfig.initialAudienceConfirmation &&
            scheduleTypeList.some(
                (data) => {
                    const countRange =
                        selectedScheduleConfig.countRanges?.[
                            data.dateCountTiming
                        ];
                    const minCount = countRange
                        ? countRange.min
                        : selectedScheduleConfig.minCount;
                    const maxCount = countRange
                        ? countRange.max
                        : selectedScheduleConfig.maxCount;

                    return (
                        !selectedScheduleConfig.allowedUnits.includes(
                            data.dateCountType,
                        ) ||
                        !selectedScheduleConfig.allowedTimings.includes(
                            data.dateCountTiming,
                        ) ||
                        Number(data.dateCount) < minCount ||
                        (maxCount !== null &&
                            Number(data.dateCount) > maxCount)
                    );
                },
            )
        ) {
            message.warning({
                content: '세그먼트 인입 전송 기준은 당일 또는 1~30일 후만 설정할 수 있습니다.',
                style: { marginTop: '90vh' },
                duration: 2,
            });
            return;
        }

        if (shouldConfirmInitialAudience()) {
            try {
                const count = await getCustomerCountBySegment({
                    group_key: jgroupKey,
                    segment_key: selectedReceiverSegments[0].segment_key,
                });
                const confirmed =
                    await requestInitialAudienceConfirmation(count);
                if (!confirmed) {
                    return;
                }
            } catch (e) {
                message.error({
                    content: '세그먼트 현재 고객 수를 조회하지 못했습니다.',
                    style: { marginTop: '90vh' },
                    duration: 2,
                });
                return;
            }
        }

        let _auto_message_type_list = [];
        let _entry_list = [];

        //전송기준이 즉시일 경우
        if (selectedOption.send_time_type === 'IMMEDIATELY') {
            if (immediatelyType) {
                _entry_list.push({
                    entry_key: null,
                    send_time_type: 'IMMEDIATELY',
                    unit_count: 0,
                    entry_type: 'EQUAL',
                    entry_unit: 'COUNT',
                    hour: 0,
                    minute: 0,
                });
            }
            if (
                scheduleType &&
                isSendTimeTypeEnabled(selectedOption, 'RELATIVELY_TIME')
            ) {
                let timeTypeList =
                    scheduleTypeList.length > 0 &&
                    scheduleTypeList.map((data) => {
                        let _hour = 0;
                        if (data.dateCountTimingType === 'MORNING') {
                            if (Number(data.sendHour) === 12) {
                                _hour = 0;
                            } else {
                                _hour = data.sendHour;
                            }
                        } else if (data.dateCountTimingType === 'AFTERNOON') {
                            if (Number(data.sendHour) === 12) {
                                _hour = 12;
                            } else {
                                _hour = data.sendHour + 12;
                            }
                        }
                        if (data.dateCountTiming === 'EQUAL') {
                            data.dateCount = 0;
                        }
                        return {
                            entry_key: data.entryKey || null,
                            send_time_type: 'RELATIVELY_TIME',
                            unit_count: data.dateCount,
                            entry_type: data.dateCountTiming,
                            entry_unit: data.dateCountType,
                            hour: _hour,
                            minute: data.sendMinute,
                        };
                    });

                if (timeTypeList) {
                    _entry_list = [..._entry_list, ...timeTypeList];
                }
            }
            //전송기준이 일정 기준일 경우
        } else if (selectedOption.send_time_type === 'RELATIVELY_TIME') {
            if (scheduleType && numberType) {
                let timeTypeList =
                    scheduleTypeList.length > 0 &&
                    scheduleTypeList.map((data) => {
                        let _hour = 0;
                        if (data.dateCountTimingType === 'MORNING') {
                            if (Number(data.sendHour) === 12) {
                                _hour = 0;
                            } else {
                                _hour = data.sendHour;
                            }
                        } else if (data.dateCountTimingType === 'AFTERNOON') {
                            if (Number(data.sendHour) === 12) {
                                _hour = 12;
                            } else {
                                _hour = data.sendHour + 12;
                            }
                        }
                        if (data.dateCountTiming === 'EQUAL') {
                            data.dateCount = 0;
                        }

                        return {
                            entry_key: data.entryKey || null,
                            send_time_type: 'RELATIVELY_TIME',
                            unit_count: data.dateCount,
                            entry_type: data.dateCountTiming,
                            entry_unit: data.dateCountType,
                            hour: _hour,
                            minute: data.sendMinute,
                        };
                    });
                let countTypeList =
                    numberTypeList.length > 0 &&
                    numberTypeList.map((data) => {
                        return {
                            entry_key: data.entryKey || null,
                            send_time_type: 'RELATIVELY_COUNT',
                            unit_count: data.count,
                            entry_type: 'MINUS',
                            entry_unit: 'COUNT',
                            hour: 0,
                            minute: 0,
                        };
                    });

                _entry_list = [...timeTypeList, ...countTypeList];
            }
            if (scheduleType && !numberType) {
                let timeTypeList =
                    scheduleTypeList.length > 0 &&
                    scheduleTypeList.map((data) => {
                        let _hour = 0;
                        if (data.dateCountTimingType === 'MORNING') {
                            if (Number(data.sendHour) === 12) {
                                _hour = 0;
                            } else {
                                _hour = data.sendHour;
                            }
                        } else if (data.dateCountTimingType === 'AFTERNOON') {
                            if (Number(data.sendHour) === 12) {
                                _hour = 12;
                            } else {
                                _hour = data.sendHour + 12;
                            }
                        }
                        if (data.dateCountTiming === 'EQUAL') {
                            data.dateCount = 0;
                        }
                        return {
                            entry_key: null,
                            send_time_type: 'RELATIVELY_TIME',
                            unit_count: data.dateCount,
                            entry_type: data.dateCountTiming,
                            entry_unit: data.dateCountType,
                            hour: _hour,
                            minute: data.sendMinute,
                        };
                    });
                _entry_list = [...timeTypeList];
            }
            if (numberType && !scheduleType) {
                let countTypeList =
                    numberTypeList.length > 0 &&
                    numberTypeList.map((data) => {
                        return {
                            entry_key: null,
                            send_time_type: 'RELATIVELY_COUNT',
                            unit_count: data.count,
                            entry_type: 'MINUS',
                            entry_unit: 'COUNT',
                            hour: 0,
                            minute: 0,
                        };
                    });

                _entry_list = [...countTypeList];
            }
        }
        _auto_message_type_list = selectedMessageTypes;

        let _newtitle = messageTitle.replace('(광고)', '');
        const createAutoMessageData = {
            name: autoMessageName ? autoMessageName : '',
            title: _newtitle ? _newtitle : '',
            body: messageBody ? messageBody : '',
            function_type: effectiveFunctionType, //selectedOption.function_type && selectedOption.function_type,
            auto_message_type_list: _auto_message_type_list,
            entry_list: _entry_list,
            status: 'ENABLED',
            calling_number: selectedNumber ?? selectedNumber,
            segment_keys: selectedReceiverSegments.map(
                (data) => data.segment_key,
            ),
            segment_entry_target_scope:
                selectedOptionConfig.initialAudienceConfirmation?.targetScope,
            coupon_parent_key: selectCoupon.coupon_key
                ? selectCoupon.coupon_key
                : null,
            has_advertisement: isAdInformation,
        };
        if (isModify && selectedData) {
            createAutoMessageData.status = isActive ? 'ENABLED' : 'DISABLED';
            dispatch(
                modifyAutoMessageSettigAction({
                    modifyData: createAutoMessageData,
                    auto_message_key: selectedData.auto_message_key,
                    jgroup_key: jgroupKey,
                }),
            );
        } else {
            dispatch(
                createAutoMessageAction({
                    createAutoMessageData: createAutoMessageData,
                    jgroup_key: jgroupKey,
                }),
            );
        }
        setFinished(true);
    };

    const titleInputClick = (e) => {
        setCursorPosition(e.target.selectionStart);
    };

    const titleInputOnkeyUp = (e) => {
        setCursorPosition(e.target.selectionStart);
    };

    const bodyInputClick = (e) => {
        setCursorPosition(e.target.selectionStart);
    };

    const bodyInputOnkeyUp = (e) => {
        setCursorPosition(e.target.selectionStart);
    };

    const handleIsActiveToggle = () => {
        setIsActive((isActive) => !isActive);
    };
    // console.log(isActive);
    const MenuItem = Menu.Item;

    const menuStyle = {
        backgroundColor: '#4a4a4a',
    };

    const menuItemStyle = {
        background: 'none',
        color: '#ffffff',
    };

    const couponItemStyle = {
        background: 'none',
        // background: "red",
        color: '#ffffff',
        display: 'flex',
        // flexDirection: "row",
        // height: "100px",
    };

    const couponMenuStyle2 = {
        backgroundColor: '#4a4a4a',
        height: '300px',
        overflowY: 'scroll',
    };

    const receiverSegmentMenu = (
        <Menu style={menuStyle} onClick={handleSelectReceiverSegment}>
            {receiverSegmentList.length > 0 ? (
                receiverSegmentList.map((data) => {
                    const isSelected = selectedReceiverSegmentKeys.includes(
                        String(data.segment_key),
                    );
                    const isDisabled =
                        isSelected ||
                        selectedReceiverSegments.length >=
                            selectedOptionConfig.receiverSegmentLimit;

                    return (
                        <MenuItem
                            key={data.segment_key}
                            style={menuItemStyle}
                            disabled={isDisabled}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    gap: '12px',
                                }}
                            >
                                <span>
                                    {data.segment_type === 'DEFAULT'
                                        ? getDefaultSegmentTitle(
                                              data.segment_name,
                                          )
                                        : data.segment_name}
                                </span>
                                {data.result_count !== undefined && (
                                    <span>{data.result_count}명</span>
                                )}
                            </div>
                        </MenuItem>
                    );
                })
            ) : (
                <MenuItem disabled style={menuItemStyle}>
                    선택 가능한 세그먼트가 없습니다.
                </MenuItem>
            )}
        </Menu>
    );

    const coupondataList = (
        <Menu style={couponMenuStyle2} onClick={handleSelectCoupon}>
            {/* <MenuItem key="sms" style={menuItemStyle}>
        문자
      </MenuItem>
      <MenuItem key="push" style={menuItemStyle}>
        운톡 푸쉬 알림
      </MenuItem>
      <MenuItem key="double" style={menuItemStyle}>
        문자 + 운톡 푸쉬 알림
      </MenuItem>
      <MenuItem key="smart_push" style={menuItemStyle}>
        문자 + 운톡 푸쉬 알림
      </MenuItem> */}
            {couponList && couponList.length > 0 ? (
                couponList.map((data) => {
                    return (
                        <MenuItem key={data.jgcp_key} style={couponItemStyle}>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'baseline',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Text>{data.jgcp_name}</Text>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'flex-end',
                                    }}
                                >
                                    {data.period_type && (
                                        <Text color="#A4A4A4">
                                            {data.period_type === 'DAYS'
                                                ? `발행일로부터 ${data.jgcp_preiod_day}일 이내`
                                                : `${moment(
                                                      data.jgcp_period_start,
                                                  ).format(
                                                      'YYYY.MM.DD',
                                                  )} ~ ${moment(
                                                      data.jgcp_period_end,
                                                  ).format('YYYY.MM.DD')}`}
                                        </Text>
                                    )}
                                    {data.jgcp_limited && (
                                        <Text>
                                            {data.jgcp_limited
                                                ? `${
                                                      data.jgcp_limit_count -
                                                      data.issued_coupons_size
                                                  }/${data.jgcp_limit_count}`
                                                : '무제한'}
                                        </Text>
                                    )}
                                </div>
                            </div>
                        </MenuItem>
                    );
                })
            ) : (
                <MenuItem>사용 가능한 쿠폰이 없습니다.</MenuItem>
            )}
        </Menu>
    );

    const formRefs = useRef();
    const sendHourInputRef = useRef();
    const isExpandedProductTab = activeOptionTab === '2';
    const optionSelectorHeight = isExpandedProductTab ? '410px' : '300px';
    const optionSelectorBodyHeight = isExpandedProductTab ? '377px' : '267px';

    if (isModify && getKakaoAlimTalkTemplatesLoading) {
        return <CustomSpinner />;
    }

    return (
        <ModalScreen className="message-setting-modal">
            <PositionController>
                <Form ref={formRefs} onFinish={onFinish}>
                    <FormContainer ref={formRef}>
                        <ModalHeader>
                            <LeftHeader>
                                <Title>자동알림 설정 추가</Title>
                            </LeftHeader>
                            <RightHeader style={{ flexDirection: 'row' }}>
                                <Spacer size={5} />
                                {isModify && (
                                    <IsUse
                                        onClick={handleIsActiveToggle}
                                        type="button"
                                    >
                                        <Text style={{ fontWeight: '500' }}>
                                            사용 여부
                                        </Text>{' '}
                                        <Form.Item name="active">
                                            <Switch
                                                checked={isActive}
                                                name="active"
                                            />
                                        </Form.Item>
                                    </IsUse>
                                )}
                                <Spacer size={10} />
                                <CloseButton
                                    type="button"
                                    onClick={() => {
                                        if (isModify) {
                                            handleSetCancel();
                                        } else {
                                            closeSetAddModal();
                                        }
                                    }}
                                >
                                    <CloseIcon
                                        src={
                                            process.env.PUBLIC_URL +
                                            '/assets/images/icon/white/x.png'
                                        }
                                    ></CloseIcon>
                                </CloseButton>
                            </RightHeader>
                        </ModalHeader>
                        <FormWrapper isSelectOption={isSelectOption}>
                            <Spacer size="12" />
                            {selectedOptionConfig.description && (
                                <Text
                                    color="#A4A4A4"
                                    style={{
                                        display: 'block',
                                        margin: '0 12px 12px',
                                        lineHeight: '20px',
                                    }}
                                >
                                    {selectedOptionConfig.description}
                                </Text>
                            )}
                            <div
                                type="button"
                                onClick={handleIsSelectOption}
                                style={{
                                    padding: '12px',
                                    borderRadius: '24px',
                                    border: '1px solid #FA943D',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                }}
                            >
                                <div>
                                    <Text color="#A4A4A4">
                                        {selectedOption.label &&
                                        selectedOption.related
                                            ? relatedStringList[
                                                  selectedOption.related
                                              ] + ' > '
                                            : '옵션을 선택해주세요.'}
                                    </Text>
                                    <Text>
                                        {selectedOption.label
                                            ? selectedOption.label
                                            : ''}
                                    </Text>
                                </div>
                                <Icon
                                    width="12px"
                                    height="6px"
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/assets/images/icon/select/toggle_down.png'
                                    }
                                />
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    overflow: 'hidden',
                                    position: 'absolute',
                                    height: isSelectOption
                                        ? optionSelectorHeight
                                        : '0px',
                                    width: '100%',
                                    transition: '0.2s',
                                    left: '0px',
                                }}
                            >
                                <SelectProductWrapper enabled={isSelectOption}>
                                    <div
                                        style={{
                                            flexWrap: 'wrap',
                                            background: '#4A4A4A',
                                            padding: '12px',
                                            height: optionSelectorBodyHeight,
                                            borderRadius: '24px',
                                        }}
                                    >
                                        <Content>
                                            <Tabs
                                                className="modal-Tabs"
                                                activeKey={activeOptionTab}
                                                onChange={setActiveOptionTab}
                                                style={{ padding: '12px' }}
                                            >
                                                <TabPane
                                                    tab="고객 관련"
                                                    key="1"
                                                >
                                                    <div
                                                        style={{
                                                            marginTop: '16px',
                                                        }}
                                                    >
                                                        <Row gutter={[20, 20]}>
                                                            {customerRealtiveOptionList.map(
                                                                (
                                                                    data,
                                                                    index,
                                                                ) => (
                                                                    <Col
                                                                        span={6}
                                                                        style={{
                                                                            paddingTop: 0,
                                                                            paddingRight: 0,
                                                                            paddingBottom: 0,
                                                                            paddingLeft: 0,
                                                                        }}
                                                                        key={
                                                                            index
                                                                        }
                                                                    >
                                                                        <CustomStyleBtn
                                                                            type="button"
                                                                            onClick={() =>
                                                                                handleSelectOptionBtn(
                                                                                    data,
                                                                                )
                                                                            }
                                                                            disabled={
                                                                                data.disabled
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            padding="5px"
                                                                            key={
                                                                                data.id
                                                                            }
                                                                            background="#4a4a4a"
                                                                        >
                                                                            <Text
                                                                                color={
                                                                                    data.disabled &&
                                                                                    '#A4A4A4'
                                                                                }
                                                                            >
                                                                                {data.label
                                                                                    ? data.label
                                                                                    : ''}
                                                                            </Text>
                                                                        </CustomStyleBtn>
                                                                    </Col>
                                                                ),
                                                            )}
                                                        </Row>
                                                    </div>
                                                </TabPane>
                                                <TabPane
                                                    tab="상품 관련"
                                                    key="2"
                                                >
                                                    <div
                                                        style={{
                                                            marginTop: '16px',
                                                        }}
                                                    >
                                                        <Row gutter={[20, 24]}>
                                                            {productRelativeOptionList.map(
                                                                (
                                                                    data,
                                                                    index,
                                                                ) => (
                                                                    <Col
                                                                        span={6}
                                                                        style={{
                                                                            paddingTop: 0,
                                                                            paddingRight: 0,
                                                                            paddingBottom: 0,
                                                                            paddingLeft: 0,
                                                                        }}
                                                                        key={
                                                                            index
                                                                        }
                                                                    >
                                                                        <CustomStyleBtn
                                                                            type="button"
                                                                            onClick={() =>
                                                                                handleSelectOptionBtn(
                                                                                    data,
                                                                                )
                                                                            }
                                                                            disabled={
                                                                                data.disabled
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            padding="5px"
                                                                            key={
                                                                                data.id
                                                                            }
                                                                            background="#4a4a4a"
                                                                        >
                                                                            <Text
                                                                                color={
                                                                                    data.disabled &&
                                                                                    '#A4A4A4'
                                                                                }
                                                                            >
                                                                                {
                                                                                    data.label
                                                                                }
                                                                            </Text>
                                                                        </CustomStyleBtn>
                                                                    </Col>
                                                                ),
                                                            )}
                                                        </Row>
                                                    </div>
                                                </TabPane>
                                                <TabPane
                                                    tab="예약 관련"
                                                    key="3"
                                                >
                                                    <div
                                                        style={{
                                                            marginTop: '16px',
                                                        }}
                                                    >
                                                        <Row gutter={[20, 24]}>
                                                            {reservationRelativeOptionList.map(
                                                                (
                                                                    data,
                                                                    index,
                                                                ) => (
                                                                    <Col
                                                                        span={6}
                                                                        style={{
                                                                            paddingTop: 0,
                                                                            paddingRight: 0,
                                                                            paddingBottom: 0,
                                                                            paddingLeft: 0,
                                                                        }}
                                                                        key={
                                                                            index
                                                                        }
                                                                    >
                                                                        <CustomStyleBtn
                                                                            type="button"
                                                                            onClick={() =>
                                                                                handleSelectOptionBtn(
                                                                                    data,
                                                                                )
                                                                            }
                                                                            disabled={
                                                                                data.disabled
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            padding="5px"
                                                                            key={
                                                                                data.id
                                                                            }
                                                                            background="#4a4a4a"
                                                                        >
                                                                            <Text
                                                                                color={
                                                                                    data.disabled &&
                                                                                    '#A4A4A4'
                                                                                }
                                                                            >
                                                                                {
                                                                                    data.label
                                                                                }
                                                                            </Text>
                                                                        </CustomStyleBtn>
                                                                    </Col>
                                                                ),
                                                            )}
                                                        </Row>
                                                    </div>
                                                </TabPane>
                                            </Tabs>
                                        </Content>
                                    </div>
                                </SelectProductWrapper>
                            </div>
                            <Spacer size="12" />
                            <div
                                className={
                                    selectedOption && selectedOption.label
                                        ? ''
                                        : 'disabled'
                                }
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                    }}
                                >
                                    <LeftContent>
                                        <Text color="#FA943D" fontWeight="700">
                                            01
                                        </Text>
                                        <Text style={{ paddingLeft: '12px' }}>
                                            자동알림명
                                        </Text>
                                    </LeftContent>
                                    <Form.Item
                                    // name="automessage-name"
                                    // // initialValue={autoMessageName}
                                    // rules={[{ validator: validateAutoMessageName }]}
                                    >
                                        <RightContent>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    width: '100%',
                                                }}
                                            >
                                                <Input
                                                    // name="automessage-name"
                                                    placeholder="자동알림 템플릿 명을 입력해주세요"
                                                    style={{
                                                        padding: '12px',
                                                        width: '100%',
                                                    }}
                                                    autoComplete="off"
                                                    // defaultValue={autoMessageName}
                                                    value={autoMessageName}
                                                    onChange={handleNameChange}
                                                />
                                                {selectedOption &&
                                                    (selectedOption.function_type ===
                                                        'ACTIVE_CUSTOMER_ALARM' ||
                                                        selectedOption.function_type ===
                                                            'INACTIVE_CUSTOMER_ALARM') && (
                                                        <AutomaticMessageNameLabel
                                                            function_type={
                                                                selectedOption.function_type
                                                            }
                                                        />
                                                    )}
                                            </div>
                                        </RightContent>
                                    </Form.Item>
                                </div>
                                <Spacer size="12" />
                                <Content
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        overflow: 'visible',
                                    }}
                                >
                                    <LeftContent>
                                        <Text color="#FA943D" fontWeight="700">
                                            02
                                        </Text>
                                        <Text style={{ paddingLeft: '12px' }}>
                                            수신 대상
                                        </Text>
                                    </LeftContent>
                                    <RightContent
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-start',
                                        }}
                                    >
                                        <Form.Item style={{ width: '100%' }}>
                                            <Dropdown
                                                getPopupContainer={(
                                                    triggerNode,
                                                ) => triggerNode.parentNode}
                                                popupStyle={{ zIndex: 10500 }}
                                                trigger={['click']}
                                                overlay={receiverSegmentMenu}
                                                overlayStyle={{
                                                    position: 'absolute',
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        background: '#4a4a4a',
                                                        padding: '12px',
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        width: '100%',
                                                        justifyContent:
                                                            'space-between',
                                                        borderRadius: '5px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    <Text>
                                                        {selectedReceiverSegments.length ===
                                                            0 &&
                                                            '세그먼트 선택'}
                                                    </Text>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexWrap: 'wrap',
                                                            gap: '6px',
                                                            flex: 1,
                                                            marginLeft:
                                                                selectedReceiverSegments.length >
                                                                0
                                                                    ? '0px'
                                                                    : '8px',
                                                        }}
                                                    >
                                                        {selectedReceiverSegments.map(
                                                            (segment) => (
                                                                <SegmentChip
                                                                    key={
                                                                        segment.segment_key
                                                                    }
                                                                    role="button"
                                                                    tabIndex={
                                                                        0
                                                                    }
                                                                    onClick={(
                                                                        e,
                                                                    ) => {
                                                                        e.stopPropagation();
                                                                        handleRemoveReceiverSegment(
                                                                            segment.segment_key,
                                                                        );
                                                                    }}
                                                                    onKeyDown={(
                                                                        e,
                                                                    ) => {
                                                                        if (
                                                                            e.key !==
                                                                                'Enter' &&
                                                                            e.key !==
                                                                                ' '
                                                                        ) {
                                                                            return;
                                                                        }

                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        handleRemoveReceiverSegment(
                                                                            segment.segment_key,
                                                                        );
                                                                    }}
                                                                >
                                                                    <span>
                                                                        {
                                                                            segment.segment_type ===
                                                                            'DEFAULT'
                                                                                ? getDefaultSegmentTitle(
                                                                                      segment.segment_name,
                                                                                  )
                                                                                : segment.segment_name
                                                                        }
                                                                    </span>
                                                                    <SegmentChipRemove
                                                                        type="button"
                                                                        onClick={(
                                                                            e,
                                                                        ) => {
                                                                            e.stopPropagation();
                                                                            handleRemoveReceiverSegment(
                                                                                segment.segment_key,
                                                                            );
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={
                                                                                process
                                                                                    .env
                                                                                    .PUBLIC_URL +
                                                                                '/assets/images/icon/white/x.png'
                                                                            }
                                                                            alt="삭제"
                                                                        />
                                                                    </SegmentChipRemove>
                                                                </SegmentChip>
                                                            ),
                                                        )}
                                                    </div>
                                                    <Icon
                                                        width="12px"
                                                        height="6px"
                                                        src={
                                                            process.env
                                                                .PUBLIC_URL +
                                                            '/assets/images/icon/select/toggle_down.png'
                                                        }
                                                    />
                                                </div>
                                            </Dropdown>
                                        </Form.Item>
                                        <Text
                                            style={{ marginTop: '6px' }}
                                            color="#a4a4a4"
                                        >
                                            {selectedOptionConfig.initialAudienceConfirmation
                                                ? '*세그먼트 인입 자동알림은 고객 세그먼트 1개를 선택해야 합니다.'
                                                : `*수신 대상 미선택 시, 전체 고객을 대상으로 발송됩니다. 최대 ${selectedOptionConfig.receiverSegmentLimit}개까지 선택할 수 있습니다.`}
                                        </Text>
                                    </RightContent>
                                </Content>
                                <Spacer size="12" />
                                <Content
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        overflow: 'visible',
                                    }}
                                >
                                    <LeftContent>
                                        <Text color="#FA943D" fontWeight="700">
                                            03
                                        </Text>
                                        <Text style={{ paddingLeft: '12px' }}>
                                            전송 기준
                                        </Text>
                                    </LeftContent>
                                    <RightContent
                                        style={{
                                            flexDirection: 'column',
                                            // justifyContent: "flex-start",
                                            alignItems: 'flex-start',
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                            }}
                                        >
                                            <Form.Item>
                                                <Checkbox
                                                    checked={immediatelyType}
                                                    onChange={
                                                        handleImmediatelyTypeChange
                                                    }
                                                    disabled={
                                                        !isSendTimeTypeEnabled(
                                                            selectedOption,
                                                            'IMMEDIATELY',
                                                        )
                                                    }
                                                >
                                                    즉시
                                                </Checkbox>
                                            </Form.Item>
                                            <Form.Item>
                                                <Checkbox
                                                    checked={scheduleType}
                                                    onChange={
                                                        handleSchduleTypeChange
                                                    }
                                                    disabled={
                                                        !isSendTimeTypeEnabled(
                                                            selectedOption,
                                                            'RELATIVELY_TIME',
                                                        )
                                                    }
                                                >
                                                    일정 기준
                                                </Checkbox>
                                            </Form.Item>
                                            <Form.Item>
                                                <Checkbox
                                                    checked={numberType}
                                                    onChange={
                                                        handleNumberTypeChange
                                                    }
                                                    disabled={
                                                        !numberEnabledFunctionTypes.includes(
                                                            selectedOption.function_type,
                                                        )
                                                    }
                                                >
                                                    횟수 기준
                                                </Checkbox>
                                            </Form.Item>
                                            {numberType && scheduleType && (
                                                <Text
                                                    fontWeight="700"
                                                    color="#EB5252"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    {
                                                        '*두 조건 중 하나라도 충족되면 자동알림이 발송됩니다'
                                                    }
                                                </Text>
                                            )}
                                        </div>
                                        {/* </Content> */}
                                        {!scheduleType && numberType ? null : (
                                            <Divider
                                                style={{
                                                    marginTop: '12px',
                                                    marginBottom: '12px',
                                                }}
                                            />
                                        )}
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                width: '100%',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                }}
                                            >
                                                {immediatelyType &&
                                                !scheduleType ? (
                                                    <Text fontWeight="700">
                                                        {`'${selectedOption.label}' 즉시 전송만 가능`}
                                                        {selectedOption.function_type ===
                                                        'LESSON_BOOK_ALARM'
                                                            ? ' / 고정예약 제외'
                                                            : ''}
                                                        {selectedOption.function_type ===
                                                        'LESSON_CANCEL_BOOK_ALARM'
                                                            ? ' / 고정예약 취소 제외'
                                                            : ''}
                                                    </Text>
                                                ) : scheduleType ? (
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            width: '100%',
                                                        }}
                                                    >
                                                        {scheduleTypeList &&
                                                            scheduleTypeList.length >
                                                                0 &&
                                                            scheduleTypeList.map(
                                                                (data, idx) => {
                                                                    return (
                                                                        <ScheduleTypeData
                                                                            scheduleTypeList={
                                                                                scheduleTypeList
                                                                            }
                                                                            setScheduleTypeList={
                                                                                setScheduleTypeList
                                                                            }
                                                                            key={
                                                                                idx
                                                                            }
                                                                            idx={
                                                                                idx
                                                                            }
                                                                            dateCount={
                                                                                data.dateCount
                                                                            }
                                                                            dateCountTiming={
                                                                                data.dateCountTiming
                                                                            }
                                                                            dateCountType={
                                                                                data.dateCountType
                                                                            }
                                                                            dateCountTimingType={
                                                                                data.dateCountTimingType
                                                                            }
                                                                            sendHour={
                                                                                data.sendHour
                                                                            }
                                                                            sendMinute={
                                                                                data.sendMinute
                                                                            }
                                                                            selectedOption={
                                                                                selectedOption
                                                                            }
                                                                            handleDateCountChange={
                                                                                handleDateCountChange
                                                                            }
                                                                            // dateCountTypeList={dateCountTypeList}
                                                                            // dateCountTimingList={dateCountTimingList}
                                                                            // dateCountTimingTypeList={
                                                                            //   dateCountTimingTypeList
                                                                            // }
                                                                            handleSendHourChange={
                                                                                handleSendHourChange
                                                                            }
                                                                            handleDateCountTypeChange={
                                                                                handleDateCountTypeChange
                                                                            }
                                                                            handleDateCountTimingChange={
                                                                                handleDateCountTimingChange
                                                                            }
                                                                            hangleDateCountTimingTypeChange={
                                                                                hangleDateCountTimingTypeChange
                                                                            }
                                                                            sendHourInputRef={
                                                                                sendHourInputRef
                                                                            }
                                                                            handleSendMinuteChange={
                                                                                handleSendMinuteChange
                                                                            }
                                                                        />
                                                                    );
                                                                },
                                                            )}
                                                        <div
                                                            style={{
                                                                marginTop:
                                                                    '12px',
                                                                display: 'flex',
                                                                flexDirection:
                                                                    'column',
                                                            }}
                                                        >
                                                            <Text>
                                                                *현재 시간보다
                                                                이전으로 설정할
                                                                경우 익일 알림이
                                                                발송됩니다.
                                                            </Text>
                                                            {/* (1회 발송)이 붙은 항목만 노출 */}
                                                            {selectedOptionConfig.oneTime && (
                                                                <>
                                                                    <Text>
                                                                        *자동알림은{' '}
                                                                        <Text
                                                                            style={{
                                                                                textDecoration:
                                                                                    'underLine',
                                                                            }}
                                                                            color="#FA6400"
                                                                        >
                                                                            최초
                                                                            1회
                                                                            발송
                                                                            후
                                                                            자동
                                                                        </Text>
                                                                        으로
                                                                        꺼집니다.
                                                                    </Text>
                                                                </>
                                                            )}
                                                            {renderSendOnlyActiveCustomerView(
                                                                selectedOption.function_type,
                                                            )}
                                                        </div>

                                                        <div
                                                            style={{
                                                                marginTop:
                                                                    '12px',
                                                            }}
                                                        >
                                                            <CustomStyleBtn
                                                                type="button"
                                                                onClick={
                                                                    addScheduleTypeList
                                                                }
                                                                style={{
                                                                    padding:
                                                                        '12px 85px 12px 85px',
                                                                }}
                                                                background="#4A4A4A"
                                                                borderRadius="22px"
                                                            >
                                                                <Icon
                                                                    width="20px"
                                                                    height="20px"
                                                                    src={
                                                                        process
                                                                            .env
                                                                            .PUBLIC_URL +
                                                                        '/assets/images/icon/white/plus.png'
                                                                    }
                                                                    style={{
                                                                        marginRight:
                                                                            '6px',
                                                                    }}
                                                                />

                                                                <Text fontWeight="700">
                                                                    전송시간
                                                                    추가
                                                                </Text>
                                                            </CustomStyleBtn>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                            {numberType ? (
                                                <Divider
                                                    style={{
                                                        marginTop: '12px',
                                                        marginBottom: '12px',
                                                    }}
                                                />
                                            ) : null}
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    width: '100%',
                                                }}
                                            >
                                                {numberType ? (
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            width: '100%',
                                                        }}
                                                    >
                                                        {numberTypeList &&
                                                            numberTypeList.length >
                                                                0 &&
                                                            numberTypeList.map(
                                                                (data, idx) => {
                                                                    return (
                                                                        <NumberTypeData
                                                                            key={
                                                                                idx
                                                                            }
                                                                            idx={
                                                                                idx
                                                                            }
                                                                            selectedOption={
                                                                                selectedOption
                                                                            }
                                                                            count={
                                                                                data.count
                                                                            }
                                                                            handleCountChange={
                                                                                handleCountChange
                                                                            }
                                                                            numberTypeList={
                                                                                numberTypeList
                                                                            }
                                                                            setNumberTypeList={
                                                                                setNumberTypeList
                                                                            }
                                                                        />
                                                                    );
                                                                },
                                                            )}
                                                        <div
                                                            style={{
                                                                marginTop:
                                                                    '12px',
                                                            }}
                                                        >
                                                            <CustomStyleBtn
                                                                type="button"
                                                                onClick={
                                                                    addNumverTypeList
                                                                }
                                                                style={{
                                                                    padding:
                                                                        '12px 85px 12px 85px',
                                                                }}
                                                                background="#4A4A4A"
                                                                borderRadius="22px"
                                                            >
                                                                <Icon
                                                                    width="20px"
                                                                    height="20px"
                                                                    src={
                                                                        process
                                                                            .env
                                                                            .PUBLIC_URL +
                                                                        '/assets/images/icon/white/plus.png'
                                                                    }
                                                                    style={{
                                                                        marginRight:
                                                                            '6px',
                                                                    }}
                                                                />

                                                                <Text fontWeight="700">
                                                                    전송시간
                                                                    추가
                                                                </Text>
                                                            </CustomStyleBtn>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </RightContent>
                                </Content>
                                <Spacer size="12" />
                                <Content
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        overflow: 'visible',
                                    }}
                                >
                                    <LeftContent>
                                        <Text color="#FA943D" fontWeight="700">
                                            04
                                        </Text>
                                        <Text style={{ paddingLeft: '12px' }}>
                                            전송 방법
                                        </Text>
                                    </LeftContent>
                                    <RightContent
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-start',
                                        }}
                                    >
                                        <Form.Item style={{ width: '100%' }}>
                                            <Checkbox.Group
                                                value={selectedMessageTypes}
                                                onChange={
                                                    handleChangeMessageTypes
                                                }
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                }}
                                            >
                                                {autoMessageTypesList.map(
                                                    (item) => (
                                                        <Content
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection:
                                                                    'row',
                                                            }}
                                                            key={item.value}
                                                        >
                                                            <Checkbox
                                                                value={
                                                                    item.value
                                                                }
                                                                disabled={
                                                                    // 조건 1: 스마트 전송 선택 시, 알림톡 외에는 disable
                                                                    (selectedMessageTypes.includes(
                                                                        'SMART_PUSH',
                                                                    ) &&
                                                                        item.value !==
                                                                            'SMART_PUSH' &&
                                                                        item.value !==
                                                                            'KAKAO_ALIM_TALK') ||
                                                                    // 조건 2: 특정 function_type에서는 알림톡 비활성화
                                                                    selectedOptionConfig.messageTypes.disabled.includes(
                                                                        item.value,
                                                                    )
                                                                }
                                                            >
                                                                {item.label}
                                                            </Checkbox>
                                                            {/* popover */}
                                                            <div
                                                                style={{
                                                                    display:
                                                                        'flex',
                                                                    alignItems:
                                                                        'center',
                                                                    justifyContent:
                                                                        'center',
                                                                }}
                                                            >
                                                                <Popover
                                                                    content={
                                                                        item.tooltipContent
                                                                    }
                                                                    getPopupContainer={(
                                                                        triggerNode,
                                                                    ) =>
                                                                        document.body
                                                                    }
                                                                    placement="bottom"
                                                                    popupStyle={{
                                                                        zIndex: 10002,
                                                                        width: 'max-content',
                                                                    }}
                                                                >
                                                                    <Icon
                                                                        style={{
                                                                            marginLeft:
                                                                                '3px',
                                                                        }}
                                                                        width="16px"
                                                                        height="16px"
                                                                        src={
                                                                            process
                                                                                .env
                                                                                .PUBLIC_URL +
                                                                            '/assets/images/icon/select/Shape.png'
                                                                        }
                                                                    />
                                                                </Popover>
                                                            </div>
                                                        </Content>
                                                    ),
                                                )}
                                            </Checkbox.Group>
                                        </Form.Item>
                                        <Content
                                            style={{
                                                flexDirection: 'column',
                                                display: 'flex',
                                            }}
                                        >
                                            <Text
                                                style={{
                                                    marginTop: '6px',
                                                    paddingBottom: '5px',
                                                }}
                                                color="#a4a4a4"
                                            >
                                                {`* 알림톡과 문자메시지를 함께 선택해도, 문자메시지는 알림톡 실패 시 한 번만 전송되어 중복되지 않습니다.`}
                                            </Text>
                                            <Text color="#EB5252">
                                                {`* 발신번호 미등록시 문자메시지가 전송되지 않습니다.`}
                                            </Text>
                                            <Text color="#EB5252">
                                                {`* 문자포인트가 소진될 경우 문자메시지가 전송되지 않습니다.`}
                                            </Text>
                                        </Content>
                                    </RightContent>
                                </Content>
                                <Spacer size="12" />
                                <Content
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                    }}
                                >
                                    <LeftContent>
                                        <Text color="#FA943D" fontWeight="700">
                                            05
                                        </Text>
                                        <Text style={{ paddingLeft: '12px' }}>
                                            파일 첨부
                                        </Text>
                                    </LeftContent>
                                    <RightContent
                                        style={{
                                            flexDirection: 'column',
                                            // justifyContent: "flex-start",
                                            alignItems: 'flex-start',
                                        }}
                                    >
                                        <CustomStyleBtn
                                            type="button"
                                            style={{
                                                padding: '12px 70px 12px 70px',
                                                opacity: '50%',
                                            }}
                                            background="#4A4A4A"
                                            borderRadius="22px"
                                            disabled={true}
                                        >
                                            <Text fontWeight="700">
                                                이미지 선택하기 (준비중)
                                            </Text>
                                        </CustomStyleBtn>
                                        <Spacer size="3" />
                                        <Text color="#A4A4A4">
                                            {`* 1440*1440px 이하 파일만 첨부 가능
                    `}
                                        </Text>
                                        <Text color="#A4A4A4">
                                            {`
                    * 각 300KB (최대2장), jpg/jpeg 만 첨부 가능`}
                                        </Text>
                                    </RightContent>
                                </Content>
                                <Spacer size="12" />
                                <Content
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        overflow: 'visible',
                                        // minHeight: "100px",
                                    }}
                                >
                                    <LeftContent>
                                        <Text color="#FA943D" fontWeight="700">
                                            06
                                        </Text>
                                        <Text style={{ paddingLeft: '12px' }}>
                                            쿠폰 첨부
                                        </Text>
                                    </LeftContent>
                                    <RightContent
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-start',
                                        }}
                                    >
                                        <Form.Item style={{ width: '100%' }}>
                                            <Dropdown
                                                getPopupContainer={(
                                                    triggerNode,
                                                ) => triggerNode.parentNode}
                                                popupStyle={{ zIndex: 10500 }}
                                                trigger={['click']}
                                                overlay={coupondataList}
                                                // position="relative"
                                                overlayStyle={{
                                                    position: 'absolute',
                                                }}
                                                style={{ height: '100%' }}
                                                disabled={
                                                    selectedOption.function_type ===
                                                    'CUSTOMER_COUPON_EXPIRE_ALARM'
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <div
                                                    style={{
                                                        background: '#4a4a4a',
                                                        padding: '12px',
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        width: '100%',
                                                        justifyContent:
                                                            'space-between',
                                                        // marginLeft: "10px",
                                                        // cursor: "pointer",
                                                        // position: "relative",
                                                        // height: "100%",
                                                        borderRadius: '5px',
                                                        opacity:
                                                            selectedOption.function_type ===
                                                            'CUSTOMER_COUPON_EXPIRE_ALARM'
                                                                ? '50%'
                                                                : null,
                                                    }}
                                                >
                                                    <Text>
                                                        {selectCoupon &&
                                                        selectCoupon.label
                                                            ? selectCoupon.label
                                                            : '쿠폰 선택'}
                                                    </Text>
                                                    <Icon
                                                        width="12px"
                                                        height="6px"
                                                        src={
                                                            process.env
                                                                .PUBLIC_URL +
                                                            '/assets/images/icon/select/toggle_down.png'
                                                        }
                                                    />
                                                </div>
                                            </Dropdown>
                                        </Form.Item>
                                        <Text
                                            style={{ marginTop: '6px' }}
                                            color="#a4a4a4"
                                        >
                                            * 쿠폰은 최대 1개까지만 첨부
                                            가능하며, 문자메시지 또는 운톡
                                            푸쉬알림으로 전송됩니다.
                                        </Text>
                                        <Text color="#a4a4a4">
                                            * 무제한 수량 쿠폰만 선택
                                            가능합니다.
                                        </Text>
                                        <Text color="#FA943D">
                                            * 쿠폰 첨부 시 "쿠폰이
                                            발급되었습니다" 문구와 함께 쿠폰명,
                                            링크가 포함되어 byte 차이가 발생할
                                            수 있습니다.
                                        </Text>
                                    </RightContent>
                                </Content>
                                <Spacer size="12" />
                                <Content
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        overflow: 'visible',
                                        // height: "100%",
                                    }}
                                >
                                    <LeftContent>
                                        <Text color="#FA943D" fontWeight="700">
                                            07
                                        </Text>
                                        <Text style={{ paddingLeft: '12px' }}>
                                            메세지 입력
                                        </Text>
                                    </LeftContent>
                                    <RightContent
                                        style={{
                                            flexDirection: 'row',
                                            // justifyContent: "flex-start",
                                            alignItems: 'flex-start',
                                        }}
                                    >
                                        <Content
                                            style={{
                                                display: 'flex',
                                                flex: 6,
                                                flexDirection: 'column',
                                                // justifyContent: "flex-start",
                                                alignItems: 'flex-start',
                                                overflow: 'visible',
                                                // height: "100%",
                                                // height: '380px',
                                                // maxHeight: '380px',
                                            }}
                                        >
                                            {hasDualTemplate && (
                                                <Form.Item
                                                    name="function_type"
                                                    initialValue={
                                                        templateOption
                                                    }
                                                >
                                                    <Content
                                                        style={{
                                                            height: '30px',
                                                        }}
                                                    >
                                                        <Radio.Group
                                                            name="function_type"
                                                            disabled={
                                                                !isSelectedAlimTalk
                                                            }
                                                            style={{
                                                                opacity:
                                                                    !isSelectedAlimTalk
                                                                        ? 0.2
                                                                        : 'unset',
                                                                pointerEvents:
                                                                    !isSelectedAlimTalk
                                                                        ? 'none'
                                                                        : 'auto',
                                                            }}
                                                            defaultValue={
                                                                templateOption
                                                            }
                                                        >
                                                            {dualTemplateRadio.map(
                                                                (radioItem) => (
                                                                    <Radio
                                                                        key={
                                                                            radioItem.value
                                                                        }
                                                                        value={
                                                                            radioItem.value
                                                                        }
                                                                        onClick={
                                                                            handleDualTemplateRadio
                                                                        }
                                                                    >
                                                                        {
                                                                            radioItem.label
                                                                        }
                                                                    </Radio>
                                                                ),
                                                            )}
                                                        </Radio.Group>
                                                    </Content>
                                                </Form.Item>
                                            )}

                                            {/* 알림톡 선택 시 disabled */}
                                            <Content
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent:
                                                        'space-between',
                                                    // alignItems: "center",
                                                    overflow: 'visible',
                                                }}
                                            >
                                                <Content
                                                    style={{
                                                        flex: 3,
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        justifyContent:
                                                            'flex-start',
                                                        alignItems: 'center',
                                                        overflow: 'visible',
                                                        opacity:
                                                            isSelectedAlimTalk
                                                                ? 0.5
                                                                : 'unset',
                                                        pointerEvents:
                                                            isSelectedAlimTalk
                                                                ? 'none'
                                                                : 'auto',
                                                    }}
                                                    className="ad_info_popover"
                                                >
                                                    <Form.Item>
                                                        <Checkbox
                                                            checked={
                                                                isAdInformation
                                                            }
                                                            onChange={
                                                                handleAdInfoChange
                                                            }
                                                        />
                                                    </Form.Item>
                                                    <Spacer size="3" />
                                                    <Text>
                                                        <Text
                                                            color="#FA943D"
                                                            style={{
                                                                textDecorationLine:
                                                                    'underline',
                                                                cursor: 'pointer',
                                                            }}
                                                            onClick={
                                                                openInfoModal
                                                            }
                                                        >
                                                            광고성 정보
                                                        </Text>
                                                        가 포함되어 있습니다.
                                                    </Text>

                                                    <Spacer size="3" />
                                                    <Popover
                                                        content={
                                                            <AdInfoPopoverContent />
                                                        }
                                                        getPopupContainer={(
                                                            triggerNode,
                                                        ) =>
                                                            triggerNode.parentNode
                                                        }
                                                        popupStyle={{
                                                            zIndex: 10002,
                                                        }}
                                                    >
                                                        <Icon
                                                            width="16px"
                                                            height="16px"
                                                            src={
                                                                process.env
                                                                    .PUBLIC_URL +
                                                                '/assets/images/icon/select/Shape.png'
                                                            }
                                                        />
                                                    </Popover>
                                                </Content>
                                                <Content
                                                    style={{
                                                        flex: 1,
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        justifyContent:
                                                            'flex-end',
                                                        alignItems: 'center',
                                                        overflow: 'visible',
                                                    }}
                                                >
                                                    <Text>미리 보기</Text>
                                                    <Spacer size="3" />
                                                    <Switch
                                                        checked={isPreview}
                                                        onChange={() => {
                                                            if (isPreview) {
                                                                setIsPreview(
                                                                    false,
                                                                );
                                                                return;
                                                            }
                                                            const _previewTitle =
                                                                handleOnchangePreview(
                                                                    messageTitle,
                                                                );
                                                            const _previewBody =
                                                                handleOnchangePreview(
                                                                    messageBody,
                                                                );
                                                            setPreviewTitle(
                                                                _previewTitle,
                                                            );
                                                            setPreviewText(
                                                                _previewBody,
                                                            );
                                                            setIsPreview(true);
                                                        }}
                                                    />
                                                </Content>
                                            </Content>
                                            <div
                                                style={{
                                                    borderRadius: '20px',
                                                    backgroundColor: '#4A4A4A',
                                                    width: '100%',
                                                    opacity: isSelectedAlimTalk
                                                        ? 0.5
                                                        : 'unset',
                                                    pointerEvents:
                                                        isSelectedAlimTalk
                                                            ? 'none'
                                                            : 'auto',
                                                    // marginTop: "6px",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        backgroundColor:
                                                            '#383838',
                                                        margin: '10px',
                                                        borderRadius: '20px',
                                                        padding: '12px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        // height: "327px",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection:
                                                                'row',
                                                            justifyContent:
                                                                'space-between',
                                                            alignItems:
                                                                'center',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection:
                                                                    'row',
                                                                // justifyContent: "space-between",
                                                                alignItems:
                                                                    'center',
                                                            }}
                                                        >
                                                            <Icon
                                                                width="8px"
                                                                height="15px"
                                                                src={
                                                                    process.env
                                                                        .PUBLIC_URL +
                                                                    '/assets/images/icon/arrow_left.png'
                                                                }
                                                            />
                                                            <Text
                                                                style={{
                                                                    marginLeft:
                                                                        '6px',
                                                                }}
                                                                size="12"
                                                            >
                                                                {selectedNumber
                                                                    ? `${selectedNumber.replace(
                                                                          /^(\d{3})(\d{4})(\d{4})$/,
                                                                          '$1-$2-$3',
                                                                      )}`
                                                                    : ''}
                                                            </Text>
                                                        </div>
                                                        <div
                                                            style={{
                                                                position:
                                                                    'relative',
                                                                // pagging: "12px",
                                                                // backgroundColor: "#FA943D",
                                                                // color: "#ffffff",
                                                                // fontSize: "12px",
                                                                // alignSelf: "center",
                                                                display: 'flex',
                                                                flexDirection:
                                                                    'row',
                                                                alignItems:
                                                                    'center',
                                                                justifyContent:
                                                                    'center',
                                                                borderRadius:
                                                                    '13px',
                                                                border:
                                                                    currentMessageType &&
                                                                    currentMessageType ===
                                                                        'SMS'
                                                                        ? '1px solid #FA943D'
                                                                        : '1px solid #EB5252',

                                                                width: '70px',
                                                                height: '30px',
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    position:
                                                                        'absolute',
                                                                    borderRadius:
                                                                        '13px',
                                                                    top: 0,
                                                                    left: 0,
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    backgroundColor:
                                                                        currentMessageType &&
                                                                        currentMessageType ===
                                                                            'SMS'
                                                                            ? '#FA943D'
                                                                            : '#EB5252',
                                                                    opacity:
                                                                        '20%',
                                                                }}
                                                            ></span>
                                                            <Text
                                                                style={{
                                                                    position:
                                                                        'relative',
                                                                    zIndex: 1,
                                                                }}
                                                                size="12"
                                                                fontWeight="700"
                                                            >
                                                                {currentMessageType &&
                                                                currentMessageType ===
                                                                    'SMS'
                                                                    ? 'sms(15원)'
                                                                    : 'LMS(35원)'}
                                                            </Text>
                                                        </div>
                                                    </div>
                                                    <Form.Item
                                                    // name="title"
                                                    // rules={[
                                                    //   {
                                                    //     validator: validateTitle,
                                                    //   },
                                                    // ]}
                                                    // style={{ paddingBottom: "10px" }}
                                                    >
                                                        <Input
                                                            // name="title"
                                                            // disabled={isPreview ? true : false}
                                                            onFocus={() =>
                                                                handleFocusInput(
                                                                    'title',
                                                                )
                                                            }
                                                            // onBlur={() => handleFocusInput(null)}
                                                            onClick={
                                                                titleInputClick
                                                            }
                                                            onKeyUp={
                                                                titleInputOnkeyUp
                                                            }
                                                            value={
                                                                isPreview
                                                                    ? `[${previewTitle}]`
                                                                    : messageTitle
                                                            }
                                                            onChange={
                                                                handleMessageTitle
                                                            }
                                                            style={{
                                                                background:
                                                                    '#E9E9E9',
                                                                width: '100%',
                                                                marginTop:
                                                                    '8px',
                                                                color: '#7C7C7C',
                                                                fontWeight:
                                                                    '700',
                                                                // paddingBottom: "8px",
                                                            }}
                                                            placeholder={
                                                                isAdInformation
                                                                    ? '(광고) 제목 입력'
                                                                    : '제목 입력'
                                                            }
                                                        />
                                                    </Form.Item>
                                                    <Form.Item
                                                    // name="body"
                                                    // style={{ paddingTop: "3px", paddingBottom: "10px" }}
                                                    // rules={[
                                                    //   {
                                                    //     validator: validateBody,
                                                    //   },
                                                    // ]}
                                                    >
                                                        <Input.TextArea
                                                            // autoSize="false"
                                                            // name="body"
                                                            // disabled={isPreview ? true : false}
                                                            value={
                                                                isPreview
                                                                    ? previewText
                                                                    : messageBody
                                                            }
                                                            onFocus={() =>
                                                                handleFocusInput(
                                                                    'body',
                                                                )
                                                            }
                                                            // onBlur={() => handleFocusInput(null)}
                                                            onChange={
                                                                handleMessageBody
                                                            }
                                                            onClick={
                                                                bodyInputClick
                                                            }
                                                            onKeyUp={
                                                                bodyInputOnkeyUp
                                                            }
                                                            style={{
                                                                background:
                                                                    '#E9E9E9',
                                                                width: '100%',
                                                                marginTop:
                                                                    '8px',
                                                                color: '#7C7C7C',
                                                                fontWeight:
                                                                    '700',
                                                                minHeight:
                                                                    '210px',
                                                                // height: "210px",
                                                            }}
                                                            placeholder={`내용 입력\n90byte 초과시 LMS로 자동 전환됩니다.(제목 포함)\n특수문자 및 이모지 입력은 전송 시 입력되지 않습니다.(제목 포함)
                          `}
                                                        />
                                                        <span
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent:
                                                                    'space-between',
                                                            }}
                                                        >
                                                            {isAdInformation ? (
                                                                <div>
                                                                    <Text
                                                                        style={{
                                                                            // position: "absolute",
                                                                            display:
                                                                                'flex',

                                                                            // bottom: 10,
                                                                            // left: 2,
                                                                        }}
                                                                        color="###"
                                                                    >
                                                                        {`${jgroupData?.jgroup_name}`}
                                                                    </Text>
                                                                    <Text
                                                                        style={{
                                                                            // position: "absolute",
                                                                            display:
                                                                                'flex',

                                                                            // bottom: 10,
                                                                            // left: 2,
                                                                        }}
                                                                        color="###"
                                                                    >
                                                                        무료수신거부
                                                                        080-367-2300
                                                                    </Text>
                                                                </div>
                                                            ) : (
                                                                <Text></Text>
                                                            )}
                                                            <span
                                                                style={{
                                                                    // position: "absolute",
                                                                    display:
                                                                        'flex',
                                                                    // bottom: 10,
                                                                    // right: 2,
                                                                    // left: 1,
                                                                }}
                                                            >
                                                                <Text
                                                                    style={
                                                                        {
                                                                            // position: "absolute",
                                                                            // display: "flex",
                                                                            // bottom: 10,
                                                                            // right: 0,
                                                                            // left: 0,
                                                                        }
                                                                    }
                                                                    color="###"
                                                                >
                                                                    {byteValue}/
                                                                </Text>
                                                                <Text color="#FA943D">
                                                                    {currentMessageType &&
                                                                    currentMessageType ===
                                                                        'SMS'
                                                                        ? '90 Byte'
                                                                        : '2000 Byte'}
                                                                </Text>
                                                            </span>
                                                        </span>
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    bottom: -30,
                                                    left: 0,
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent:
                                                        'space-between',
                                                }}
                                            >
                                                <LeftContent></LeftContent>
                                                <RightContent>
                                                    <Text color="#FA943D">
                                                        *실제 이름/상품/정보 등
                                                        기준으로 byte 차이가
                                                        발생할 수 있습니다.
                                                    </Text>
                                                </RightContent>
                                            </div>
                                        </Content>
                                        {/* 알림톡 선택 시 카카오톡 ui 제공 / 아닐땐 자동입력 문구 선택 UI */}
                                        {isSelectedAlimTalk ? (
                                            <KakaoPreview
                                                functionType={
                                                    effectiveFunctionType
                                                }
                                                kakaoTemplate={
                                                    kakaoAlimTalkTemplates
                                                }
                                                handleOnchangePreview={
                                                    handleOnchangePreview
                                                }
                                                isPreview={isPreview}
                                            />
                                        ) : (
                                            <Content
                                                style={{
                                                    display: 'flex',
                                                    flex: 3,
                                                    overflow: 'visible',
                                                    height: '380px',
                                                    // maxHeight: "500px",
                                                    // overflowY: "scroll",
                                                    // margin: "12px",
                                                    padding:
                                                        '12px 12px 12px 16px',
                                                    backgroundColor: '#4A4A4A',
                                                    borderRadius: '20px',
                                                    marginTop: hasDualTemplate
                                                        ? '30px'
                                                        : '0px',
                                                    marginLeft: '24px',
                                                }}
                                                className="auto_input_popover"
                                            >
                                                <div
                                                    style={{
                                                        borderRadius: '20px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        // padding: "12px",
                                                        flex: 1,
                                                        // minHeight: "375px",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems:
                                                                'center',
                                                            justifyContent:
                                                                'center',
                                                        }}
                                                    >
                                                        <Text>
                                                            자동 입력 문구
                                                        </Text>
                                                        <Popover
                                                            content={
                                                                <AutoInputPopoverContent />
                                                            }
                                                            getPopupContainer={(
                                                                triggerNode,
                                                            ) =>
                                                                triggerNode.parentNode
                                                            }
                                                            popupStyle={{
                                                                zIndex: 10002,
                                                            }}
                                                        >
                                                            <Icon
                                                                style={{
                                                                    marginLeft:
                                                                        '3px',
                                                                }}
                                                                width="16px"
                                                                height="16px"
                                                                src={
                                                                    process.env
                                                                        .PUBLIC_URL +
                                                                    '/assets/images/icon/select/Shape.png'
                                                                }
                                                            />
                                                        </Popover>
                                                    </div>
                                                    <Text
                                                        size="12"
                                                        color="#A4A4A4"
                                                    >
                                                        * 클릭시 내용이 자동
                                                        입력됩니다.
                                                    </Text>
                                                    <div
                                                        ref={autoInputWordRef}
                                                        style={{
                                                            overflowY: 'scroll',
                                                        }}
                                                    >
                                                        {autoInputWordList &&
                                                            autoInputWordList.length >
                                                                0 &&
                                                            autoInputWordList.map(
                                                                (data) => {
                                                                    return (
                                                                        <div
                                                                            type="button"
                                                                            onClick={(
                                                                                e,
                                                                            ) =>
                                                                                handleClickAutoMessageWord(
                                                                                    e,
                                                                                    data,
                                                                                )
                                                                            }
                                                                            key={
                                                                                data.dataType
                                                                            }
                                                                            style={{
                                                                                position:
                                                                                    'relative',
                                                                                padding:
                                                                                    '15px',
                                                                                display:
                                                                                    'flex',
                                                                                flexDirection:
                                                                                    'row',
                                                                                alignItems:
                                                                                    'center',
                                                                                justifyContent:
                                                                                    'center',
                                                                                borderRadius:
                                                                                    '5px',
                                                                                marginTop:
                                                                                    '8px',
                                                                                cursor: 'pointer',
                                                                            }}
                                                                        >
                                                                            <span
                                                                                // type="button"
                                                                                // onClick={handleClickAutoMessageWord}
                                                                                style={{
                                                                                    position:
                                                                                        'absolute',
                                                                                    borderRadius:
                                                                                        '13px',
                                                                                    top: 0,
                                                                                    left: 0,
                                                                                    width: '100%',
                                                                                    height: '100%',
                                                                                    backgroundColor:
                                                                                        '#FA943D',
                                                                                    opacity:
                                                                                        '10%',
                                                                                }}
                                                                            ></span>
                                                                            <Text
                                                                                color="#FA943D"
                                                                                style={{
                                                                                    position:
                                                                                        'relative',
                                                                                    zIndex: 1,
                                                                                }}
                                                                                size="14"
                                                                                fontWeight="700"
                                                                            >
                                                                                {
                                                                                    data.label
                                                                                }
                                                                            </Text>
                                                                        </div>
                                                                    );
                                                                },
                                                            )}
                                                    </div>
                                                </div>
                                            </Content>
                                        )}
                                    </RightContent>
                                </Content>
                            </div>
                            <Spacer size={76.5} />
                        </FormWrapper>
                        <Content
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                overflow: 'visible',
                            }}
                        >
                            <ActionButtonGroup>
                                <CustomButton
                                    background={'#7c7c7c'}
                                    // onClick={handleChange}
                                    text="취소"
                                    type="button"
                                    onClick={() => {
                                        if (isModify) {
                                            handleSetCancel();
                                        } else {
                                            closeSetAddModal();
                                        }
                                    }}
                                />
                                <Form.Item style={{ margin: '0px' }}>
                                    <CustomButton
                                        // height="100px"
                                        background={'#fa6400'}
                                        // htmlType="submit"
                                        text={isModify ? '수정' : '완료'}
                                        // disabled={selectedOption.label.length > 0 ? false : true}
                                        onClick={onFinish}
                                    />
                                </Form.Item>
                            </ActionButtonGroup>
                        </Content>

                        {isCreateCompleteModal && (
                            <NoticeModal
                                multipleScreen={false}
                                multipleButton={false}
                                title="자동알림 생성 완료"
                                headerIcon="/assets/images/icon/white/v.png"
                                primaryColor="#78B2A0"
                                firstButtonText="확인"
                                body={
                                    <Text color="#000">
                                        자동알림 생성이 완료되었습니다.
                                    </Text>
                                }
                                warningText="* 자동알림 수정 페이지에서 다시 수정 가능합니다."
                                handleFirstButton={() => {
                                    document.body.style.overflow = 'unset';
                                    setIsCreateCompleteModal(
                                        (isCreateCompleteModal) =>
                                            !isCreateCompleteModal,
                                    );
                                    closeSetAddModal();
                                    dispatch(
                                        getAutoMessageSettingAction({
                                            jgroup_key: jgroupKey,
                                        }),
                                    );
                                }}
                            />
                        )}
                        {isModifyCompleteModal && (
                            <NoticeModal
                                multipleScreen={false}
                                multipleButton={false}
                                title="자동알림 수정 완료"
                                headerIcon="/assets/images/icon/white/v.png"
                                primaryColor="#78B2A0"
                                firstButtonText="확인"
                                body={
                                    <Text color="#000">
                                        자동알림 수정이 완료되었습니다.
                                    </Text>
                                }
                                warningText="* 자동알림 수정 페이지에서 다시 수정 가능합니다."
                                handleFirstButton={() => {
                                    document.body.style.overflow = 'unset';
                                    // setIsCreateCompleteModal(
                                    //   (isCreateCompleteModal) => !isCreateCompleteModal
                                    // );
                                    setIsModifyCompleteModal(
                                        (isModifyCompleteModal) =>
                                            !isModifyCompleteModal,
                                    );
                                    closeSetAddModal();
                                    dispatch(
                                        getAutoMessageSettingAction({
                                            jgroup_key: jgroupKey,
                                        }),
                                    );
                                }}
                            />
                        )}
                        {cancelModify && (
                            <NoticeModal
                                multipleScreen={false}
                                multipleButton
                                title="수정 취소"
                                headerIcon="/assets/images/icon/white/alert.png"
                                primaryColor="#F6CA4F"
                                firstButtonText="아니오"
                                secondButtonText="예"
                                warningText="* 수정사항이 적용되지 않습니다."
                                body={
                                    <Text color="#000">
                                        수정사항을 적용하지 않고 나가시겠습니까?
                                    </Text>
                                }
                                handleFirstButton={handleSetCancel}
                                handleSecondButton={() => {
                                    document.body.style.overflow = 'unset';
                                    setIsCreateCompleteModal(
                                        (isCreateCompleteModal) =>
                                            !isCreateCompleteModal,
                                    );
                                    closeSetAddModal();
                                }}
                            />
                        )}
                        {isInfoClicked && (
                            <MessageInfoNoticeModal
                                handleChange={openInfoModal}
                            />
                        )}
                        <InitialAudienceConfirmationModal
                            visible={initialAudienceConfirmation !== null}
                            title={
                                selectedOptionConfig.initialAudienceConfirmation
                                    ?.title
                            }
                            centered
                            closable
                            keyboard={false}
                            maskClosable={false}
                            zIndex={100700}
                            onCancel={() =>
                                resolveInitialAudienceConfirmation(false)
                            }
                            footer={[
                                <Button
                                    key="cancel"
                                    onClick={() =>
                                        resolveInitialAudienceConfirmation(
                                            false,
                                        )
                                    }
                                >
                                    {
                                        selectedOptionConfig
                                            .initialAudienceConfirmation
                                            ?.cancelText
                                    }
                                </Button>,
                                <Button
                                    key="confirm"
                                    type="primary"
                                    onClick={() =>
                                        resolveInitialAudienceConfirmation(
                                            true,
                                        )
                                    }
                                >
                                    {
                                        selectedOptionConfig
                                            .initialAudienceConfirmation
                                            ?.confirmText
                                    }
                                </Button>,
                            ]}
                        >
                            <Text color="#ffffff">
                                현재 이 세그먼트에{' '}
                                <strong>
                                    {initialAudienceConfirmation?.memberCount ||
                                        0}
                                    명
                                </strong>
                                의 고객이 있습니다.
                            </Text>
                            <Spacer size={2} />
                            <Text color="#d0d0d0">
                                {
                                    selectedOptionConfig
                                        .initialAudienceConfirmation
                                        ?.description
                                }
                            </Text>
                        </InitialAudienceConfirmationModal>
                    </FormContainer>
                </Form>
            </PositionController>
        </ModalScreen>
    );
};

/**
 * 장기미출석, 생일자인 경우 추가 메시지 안내
 * @param {*} functionType
 */
const renderSendOnlyActiveCustomerView = (functionType: string) => {
    switch (functionType) {
        case 'CUSTOMER_BIRTHDAY_ALARM':
        case 'CUSTOMER_NON_ATTENDANCE':
            break;
        default:
            return null;
    }

    return (
        <Text>
            {`*`}
            <Text
                style={{ textDecoration: 'underLine' }} // CUSTOMER_NON_ATTENDANCE
                color="#FA6400"
            >
                {`전송시간 기준 활성 회원`}
            </Text>
            {`에게만 발송됩니다.`}
        </Text>
    );
};

const antMoveDownIn = keyframes`
  0% {
    transform-origin: 0 0;
    transform: translateY(0);
    opacity: 1;
  }
  100%{
    transform-origin: 0 0;
    transform: translateY(-100%);
    opacity: 0;
  }
`;

const antMoveDownOut = keyframes`
  0% {
    transform-origin: 0 0;
    transform: translateY(-100%);
    opacity: 0;
  }
  100%{
    transform-origin: 0 0;
    transform: translateY(0);
    opacity: 1;
  }
`;

const ButtonStyle = `
flex-grow: 1;
border: none;
font-family: "Noto Sans KR";
font-style: normal;
font-weight: 500;
font-size: 20px;
line-height: 29px;
text-align: center;
letter-spacing: -0.670707px;
:hover {
  cursor: pointer;
}
`;

const CustomSelect = styled.div`
  width: 329px;
  height: 45px;
  color: #a4a4a4;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #4a4a4a;
  border-radius: 5px;
  border: none;
  box-sizing: border-box;
  margin: 0;
  padding: 12px;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  cursor: pointer;
`;

const SelectProductWrapper = styled.div`
  width: 100%;
  z-index: 10500;
  position: relative;
  height: 0;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
  animation-name: ${(props) =>
      props.enabled ? antMoveDownOut : antMoveDownIn};
  margin: 0px;
`;

const SegmentChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 180px;
  padding: 3px 8px;
  border: 2px solid #6a6a6a;
  border-radius: 4px;
  background: transparent;
  color: #ffffff;
  font-size: 12px;
  line-height: 18px;
  cursor: pointer;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const SegmentChipRemove = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  padding: 0;
  border: 0;
  background: transparent;
  opacity: 0.7;

  img {
    width: 8px;
    height: 8px;
    display: block;
  }

  :hover {
    opacity: 1;
    cursor: pointer;
  }
`;

const LeftContent = styled.div`
  display: flex;
  align-items: center;
`;

const RightContent = styled.div`
  width: 681px;
  display: flex;
  align-items: center;
`;

const CloseIcon = styled.img`
  /* position: absolute; */
  top: 24px;
  right: 24px;
  width: 24px;
  height: 24px;
`;

const ModalHeader = styled.div`
  position: sticky;
  top: 0;
  background: ${commonTheme.background.black4};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 30px 30px 0 30px;
  z-index: 10600;
`;

const LeftHeader = styled.div`
  display: flex;
  align-items: center;
`;

const RightHeader = styled.div`
  display: flex;
  align-items: center;
`;

const FormContainer = styled.div`
  position: relative;
  background: ${commonTheme.background.black4};
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  width: 900px;
  height: 671px;
  /* overflow: auto; */
  /* padding: 30px; */
  /* padding-bottom: 0px; */
`;

const FormWrapper = styled.div`
  width: 100%;
  height: calc(100% - 125px);
  /* overflow: scroll; */
  overflow: ${(props) => (props.isSelectOption ? 'hidden' : 'scroll')};
  padding: 0 30px;
`;

const CustomStyleBtn = styled.button`
  width: ${(props) => (props.width ? props.width : null)};
  height: ${(props) => (props.height ? props.height : null)};
  background: ${(props) => (props.background ? props.background : null)};
  border: ${(props) => (props.border ? props.border : 'none')};
  border-color: ${(props) => (props.borderColor ? props.borderColor : 'none')};
  border-radius: ${(props) =>
      props.borderRadius ? props.borderRadius : '0px'};
  padding: ${(props) => (props.padding ? props.padding : null)};
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  :hover {
    cursor: pointer;
  }
`;

const IsUse = styled.div`
  width: 115px;
  height: 33px;
  background: ${commonTheme.background.black7};
  border: none;
  border-radius: 3px;
  padding: 7px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  font-size: 14px;
  color: ${commonTheme.font.black5};
  :hover {
    cursor: pointer;
  }
`;

const InitialAudienceConfirmationModal = styled(Modal)`
  .ant-modal-content,
  .ant-modal-header,
  .ant-modal-body,
  .ant-modal-footer {
    background: ${commonTheme.background.black4};
  }

  .ant-modal-content {
    border: 1px solid #4a4a4a;
    border-radius: 6px;
    overflow: hidden;
  }

  .ant-modal-header {
    border-bottom: 1px solid #4a4a4a;
  }

  .ant-modal-title {
    color: #ffffff;
    font-family: "Noto Sans KR";
    font-weight: 700;
  }

  .ant-modal-close {
    color: #a4a4a4;
  }

  .ant-modal-close:hover {
    color: #ffffff;
  }

  .ant-modal-footer {
    border-top: 1px solid #4a4a4a;
  }

  .ant-btn {
    background: #4a4a4a;
    border-color: #666666;
    color: #ffffff;
  }

  .ant-btn:hover,
  .ant-btn:focus {
    border-color: #fa943d;
    color: #fa943d;
  }

  .ant-btn-primary,
  .ant-btn-primary:hover,
  .ant-btn-primary:focus {
    background: #fa943d;
    border-color: #fa943d;
    color: #ffffff;
  }
`;
export default MessageSettingModal;
